<div class="advanced-settings">
  <div class="container">
    <div>
      <!-- <div class="back" (click)="goBack()">
        <i class="fa fa-caret-left back-btn"></i>
        Back
      </div> -->
      <div class="back-button-section">
        <button class="back-button" (click)="goBack()"><i class="fa fa-arrow-left" aria-hidden="true"></i> Back</button>
      </div>
      <ul class="left-menu">
        <li [class.active]="tab === -1" (click)="tabChange(-1)">
          <div class="icon">
            <svg viewBox="0 0 800 600" fill="none" width="1.5rem">
              <path
                d="M775 500H100V25C100 11.1875 88.8125 0 75 0H25C11.1875 0 0 11.1875 0 25V550C0 577.609 22.3906 600 50 600H775C788.813 600 800 588.813 800 575V525C800 511.187 788.813 500 775 500ZM725 50H540.531C507.125 50 490.391 90.3906 514.016 114.016L564.641 164.641L450 279.297L335.359 164.656C315.828 145.125 284.172 145.125 264.656 164.656L157.328 271.984C147.563 281.75 147.563 297.578 157.328 307.344L192.672 342.688C202.437 352.453 218.266 352.453 228.031 342.688L300 270.703L414.641 385.344C434.172 404.875 465.828 404.875 485.344 385.344L635.344 235.344L685.969 285.969C709.594 309.594 749.984 292.859 749.984 259.453V75C750 61.1875 738.813 50 725 50Z" />
            </svg>
          </div>
          Contributions 
         
        </li>
        <li [class.active]="tab === 0" (click)="tabChange(0)">
          <div class="icon">
            <svg viewBox="0 0 800 800" fill="none" width="2rem">
              <path
                d="M800 106.667V0H0V106.667H26.6672V640H13.3328C5.33281 640 0 645.333 0 653.333C0 661.333 5.33281 666.666 13.3328 666.666H26.6656H386.666V695.031C363.73 700.991 346.666 721.931 346.666 746.666C346.667 776 370.667 800 400 800C429.333 800 453.333 776 453.333 746.667C453.333 721.933 436.269 700.992 413.333 695.033V666.667H773.333H786.666C794.666 666.667 799.998 661.334 799.998 653.334C799.998 645.334 794.666 640.002 786.666 640.002H773.333V106.667H800ZM426.667 746.667C426.667 761.334 414.667 773.334 400 773.334C385.333 773.334 373.333 761.334 373.333 746.667C373.333 732 385.333 720 400 720C414.667 720 426.667 732 426.667 746.667ZM26.6672 26.6672H773.334V80H26.6672V26.6672ZM746.667 640H53.3328V106.667H746.666V640H746.667Z" />
              <path
                d="M260 545.333C262.667 546.666 264 546.666 266.667 546.666C269.334 546.666 272 546.666 273.334 545.333L540.002 385.333C544.002 382.666 546.669 378.666 546.669 373.333C546.669 368 544.002 364 540.002 361.333L273.334 201.333C269.334 198.666 264.002 198.666 260.002 201.333C256.002 204 253.334 208 253.334 213.333V533.333C253.333 538.667 256 542.667 260 545.333ZM280 237.333L508 373.333L280 510.667V237.333Z" />
            </svg>
          </div>
          Intro
        </li>
        <li [class.active]="tab === 1" (click)="tabChange(1)">
          <div class="icon">
            <svg viewBox="0 0 734 603" fill="none" width="2rem">
              <path
                d="M33.6668 603H233.667C242.507 603 250.986 599.488 257.237 593.237C263.488 586.985 267 578.507 267 569.666C267 560.826 263.488 552.347 257.237 546.096C250.986 539.845 242.507 536.333 233.667 536.333H69.3668C77.4554 480.827 105.238 430.082 147.642 393.364C190.046 356.645 244.241 336.403 300.333 336.333C339.583 336.674 377.714 323.271 408.119 298.449C438.525 273.627 459.287 238.949 466.809 200.426C474.331 161.903 468.137 121.962 449.303 87.5255C430.468 53.0891 400.178 26.3276 363.684 11.8789C327.189 -2.56977 286.79 -3.79498 249.486 8.41564C212.183 20.6263 180.328 45.5031 159.441 78.7349C138.554 111.967 129.952 151.459 135.125 190.367C140.299 229.275 158.922 265.147 187.767 291.766C132.44 314.211 85.0591 352.636 51.6737 402.135C18.2883 451.634 0.414041 509.961 0.333496 569.666C0.333496 578.507 3.84539 586.985 10.0966 593.237C16.3478 599.488 24.8263 603 33.6668 603ZM300.333 69.6665C320.112 69.6665 339.446 75.5314 355.891 86.5195C372.335 97.5076 385.153 113.125 392.721 131.398C400.29 149.671 402.271 169.777 398.412 189.175C394.553 208.574 385.029 226.392 371.044 240.377C357.059 254.362 339.241 263.886 319.842 267.745C300.444 271.603 280.338 269.623 262.065 262.054C243.793 254.486 228.175 241.668 217.187 225.223C206.198 208.779 200.333 189.445 200.333 169.666C200.333 143.145 210.869 117.709 229.623 98.9558C248.376 80.2021 273.812 69.6665 300.333 69.6665ZM640.567 212.766C634.316 206.517 625.839 203.007 617 203.007C608.161 203.007 599.684 206.517 593.433 212.766L385.1 421.1C381.458 424.77 378.709 429.23 377.067 434.133L335.4 559.133C333.732 564.141 333.277 569.475 334.073 574.693C334.869 579.912 336.893 584.866 339.979 589.15C343.065 593.433 347.123 596.922 351.821 599.33C356.519 601.738 361.721 602.996 367 603C370.579 602.994 374.135 602.421 377.533 601.3L502.533 559.633C507.446 557.993 511.908 555.231 515.567 551.566L723.9 343.233C730.149 336.982 733.66 328.505 733.66 319.666C733.66 310.828 730.149 302.351 723.9 296.1L640.567 212.766ZM473.9 498.866L419.6 516.966L437.7 462.666L617 283.466L653.2 319.666L473.9 498.866Z" />
            </svg>
          </div>
          Edit Profile
        </li>
        <li [class.active]="tab === 2" (click)="tabChange(2)">
          <div class="icon">
            <svg viewBox="0 0 616 740" fill="none" width="2rem">
              <path
                d="M554.154 323.846H61.8461C27.9999 323.846 0.307617 351.538 0.307617 385.385V677.692C0.307617 711.538 27.9999 739.231 61.8461 739.231H554.154C588 739.231 615.692 711.538 615.692 677.692V385.385C615.692 351.538 588 323.846 554.154 323.846ZM384.923 654.615C361.846 670 335.692 677.692 308 677.692C298.769 677.692 289.538 676.154 280.308 674.615C243.385 666.923 212.615 646.923 192.615 616.154L243.385 582.308C254.154 599.231 272.615 611.539 292.615 614.615C312.615 619.231 332.615 614.615 351.077 602.308C386.461 579.231 395.692 530 372.615 496.154C361.846 479.231 343.385 466.923 323.385 463.846C303.385 459.231 283.385 463.846 264.923 476.154C260.308 479.231 257.231 482.308 254.154 485.385L308 539.231H169.538V400.769L209.538 440.769C215.692 434.615 223.385 428.462 229.538 423.846C260.308 403.846 297.231 396.154 334.154 402.308C371.077 410 401.846 430 421.846 460.769C464.923 525.385 448 611.538 384.923 654.615Z" />
              <path
                d="M77.2308 262.308H138.769C148 262.308 154.154 257.692 154.154 248.462V246.923C154.154 159.231 229.539 86.9231 318.769 93.0769C400.308 99.2307 461.846 170 461.846 253.077V248.462C461.846 257.692 468 262.308 477.231 262.308H538.769C548 262.308 554.154 257.692 554.154 248.462V246.923C554.154 106.923 437.231 -5.38464 295.692 0.769207C164.923 6.92305 64.9231 117.692 61.8462 248.462C63.3847 256.154 69.5385 262.308 77.2308 262.308Z" />
            </svg>
          </div>
          Reset Password
        </li>
        <li [class.active]="tab === 3" (click)="tabChange(3)" class="verify-shepherd">
          <div class="icon">
            <svg viewBox="0 0 668 668" fill="none" width="2rem">
              <path
                d="M652.696 291.953L607.363 239.286C598.696 229.286 591.696 210.619 591.696 197.286V140.619C591.696 105.286 562.696 76.2861 527.363 76.2861H470.696C457.696 76.2861 438.696 69.2861 428.696 60.6195L376.03 15.2861C353.03 -4.38053 315.363 -4.38053 292.03 15.2861L239.695 60.9528C229.695 69.2861 210.695 76.2861 197.695 76.2861H140.028C104.695 76.2861 75.6952 105.286 75.6952 140.619V197.619C75.6952 210.619 68.6951 229.286 60.3618 239.286L15.3618 292.286C-3.97152 315.286 -3.97152 352.62 15.3618 375.62L60.3618 428.62C68.6951 438.62 75.6952 457.286 75.6952 470.286V527.286C75.6952 562.62 104.695 591.62 140.028 591.62H197.695C210.695 591.62 229.695 598.62 239.695 607.286L292.363 652.62C315.363 672.286 353.03 672.286 376.363 652.62L429.03 607.286C439.03 598.62 457.696 591.62 471.03 591.62H527.696C563.03 591.62 592.03 562.62 592.03 527.286V470.62C592.03 457.62 599.03 438.62 607.696 428.62L653.03 375.953C672.363 352.953 672.363 314.953 652.696 291.953ZM472.696 270.953L311.696 431.953C307.03 436.62 300.696 439.286 294.03 439.286C287.363 439.286 281.03 436.62 276.363 431.953L195.695 351.286C186.028 341.62 186.028 325.62 195.695 315.953C205.362 306.286 221.362 306.286 231.028 315.953L294.03 378.953L437.363 235.619C447.03 225.953 463.03 225.953 472.696 235.619C482.363 245.286 482.363 261.286 472.696 270.953Z" />
            </svg>
          </div>
          Verify
        </li>
        <li [class.active]="tab === 4" (click)="tabChange(4)" *ngIf="false">
          <div class="icon">
            <svg viewBox="0 0 800 800" fill="none" width="2rem">
              <path
                d="M800 106.667V0H0V106.667H26.6672V640H13.3328C5.33281 640 0 645.333 0 653.333C0 661.333 5.33281 666.666 13.3328 666.666H26.6656H386.666V695.031C363.73 700.991 346.666 721.931 346.666 746.666C346.667 776 370.667 800 400 800C429.333 800 453.333 776 453.333 746.667C453.333 721.933 436.269 700.992 413.333 695.033V666.667H773.333H786.666C794.666 666.667 799.998 661.334 799.998 653.334C799.998 645.334 794.666 640.002 786.666 640.002H773.333V106.667H800ZM426.667 746.667C426.667 761.334 414.667 773.334 400 773.334C385.333 773.334 373.333 761.334 373.333 746.667C373.333 732 385.333 720 400 720C414.667 720 426.667 732 426.667 746.667ZM26.6672 26.6672H773.334V80H26.6672V26.6672ZM746.667 640H53.3328V106.667H746.666V640H746.667Z" />
              <path
                d="M260 545.333C262.667 546.666 264 546.666 266.667 546.666C269.334 546.666 272 546.666 273.334 545.333L540.002 385.333C544.002 382.666 546.669 378.666 546.669 373.333C546.669 368 544.002 364 540.002 361.333L273.334 201.333C269.334 198.666 264.002 198.666 260.002 201.333C256.002 204 253.334 208 253.334 213.333V533.333C253.333 538.667 256 542.667 260 545.333ZM280 237.333L508 373.333L280 510.667V237.333Z" />
            </svg>
          </div>
          Refer
        </li>
        <li [class.active]="tab === 5" (click)="tabChange(5)">
          <div class="icon">
            <svg viewBox="0 0 800 800" fill="none" width="2rem">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M275 165.025C241.85 165.025 215 191.875 215 225C215 258.125 241.85 285 275 285C308.15 285 335 258.125 335 225C335 191.875 308.15 165.025 275 165.025ZM500 365C466.85 365 440 391.875 440 425C440 458.125 466.85 485 500 485C533.15 485 560 458.125 560 425C560 391.875 533.15 365 500 365ZM650 250H371.45C360.325 293.075 321.55 325 275 325C228.45 325 189.675 293.075 178.55 250H150C136.2 250 125 238.825 125 225C125 211.2 136.2 200 150 200H178.55C189.675 156.925 228.45 125 275 125C321.55 125 360.325 156.925 371.45 200H650C663.8 200 675 211.2 675 225C675 238.825 663.8 250 650 250ZM650 450H596.45C585.325 493.075 546.55 525 500 525C453.45 525 414.675 493.075 403.55 450H150C136.2 450 125 438.825 125 425C125 411.2 136.2 400 150 400H403.55C414.7 356.925 453.45 325 500 325C546.55 325 585.325 356.925 596.45 400H650C663.8 400 675 411.2 675 425C675 438.825 663.8 450 650 450ZM650 650H371.45C360.325 693.075 321.55 725 275 725C228.45 725 189.675 693.075 178.55 650H150C136.2 650 125 638.825 125 625C125 611.175 136.2 600 150 600H178.55C189.675 556.95 228.45 525 275 525C321.55 525 360.325 556.95 371.45 600H650C663.8 600 675 611.175 675 625C675 638.825 663.8 650 650 650ZM700 0H100C44.775 0 0 44.775 0 100V700C0 755.225 44.775 800 100 800H700C755.225 800 800 755.225 800 700V100C800 44.775 755.225 0 700 0ZM275 565.025C241.85 565.025 215 591.875 215 625C215 658.125 241.85 685 275 685C308.15 685 335 658.125 335 625C335 591.875 308.15 565.025 275 565.025Z" />
            </svg>
          </div>
          Preferences
        </li>
        <li [class.active]="tab === 6" (click)="tabChange(6)">
          <div class="icon">
            <svg viewBox="0 0 800 664" fill="none" width="2rem">
              <path
                d="M656.279 448.74L297.454 89.9345C293.548 86.0283 288.257 83.8322 282.731 83.8322H151.361C141.891 71.8067 129.18 61.5042 114.215 54.0833C78.2074 36.1857 37.6461 39.1377 15.5402 61.2197C11.4582 65.3049 8.0906 69.9671 5.56851 75.0832C-2.59874 91.5008 -1.75325 111.014 7.92118 130.004C17.2456 148.326 33.7783 164.065 54.5 174.348C63.7957 178.962 73.3886 182.16 82.8936 184.04V283.66C82.9032 289.186 85.0992 294.496 89.0055 298.393L447.811 657.206C455.955 665.351 469.132 665.351 477.277 657.206L656.289 478.195C664.413 470.071 664.413 456.882 656.279 448.74ZM89.0055 89.9345C85.1088 93.8311 82.9032 99.1454 82.9032 104.658V169.871C75.4744 168.166 67.996 165.535 60.679 161.907C42.6216 152.942 28.2658 139.376 20.3015 123.693C12.6681 108.719 11.8562 93.6473 18.0096 81.267C19.8668 77.503 22.3329 74.0587 25.3681 71.0491C43.3041 53.1131 77.2996 51.2575 108.039 66.5244C117.407 71.1674 125.724 77.0587 132.73 83.8322H103.737C98.2068 83.8178 92.9117 86.0187 89.0055 89.9345ZM134.838 135.777C140.411 130.199 147.346 126.783 154.583 125.503C155.221 133.206 153.984 140.567 150.723 147.155C148.866 150.919 146.392 154.363 143.355 157.381C138.273 162.468 131.864 166.208 124.617 168.688C122.485 157.118 125.881 144.729 134.838 135.777ZM187.222 188.16C172.759 202.623 149.301 202.623 134.838 188.16C132.807 186.129 131.077 183.914 129.632 181.567C138.669 178.42 146.737 173.661 153.188 167.208C157.275 163.126 160.637 158.464 163.164 153.35C167.411 144.794 169.174 135.409 168.563 125.707C175.404 127.119 181.931 130.469 187.231 135.778C201.685 150.239 201.685 173.688 187.222 188.16ZM793.896 436.469L614.901 615.472C606.758 623.606 593.561 623.606 585.427 615.472L576.358 606.402L687.967 494.776C695.797 486.962 700.096 476.57 700.096 465.527C700.096 454.483 695.806 444.091 687.976 436.288L329.178 77.4646C321.342 69.6474 310.96 65.3528 299.944 65.3528H220.519V62.925C220.519 57.403 222.725 52.0998 226.636 48.192C230.542 44.2906 235.822 42.0898 241.349 42.0898H270.352C263.337 35.3258 255.01 29.4265 245.663 24.7819C214.912 9.51508 180.917 11.3723 162.982 29.3083C159.955 32.3162 157.498 35.7605 155.609 39.5261C154.721 41.345 154.013 43.2197 153.413 45.1473C149.459 42.6204 145.417 40.2198 141.18 38.0956C141.789 36.499 142.398 34.8927 143.163 33.3423C145.714 28.2374 149.063 23.5752 153.153 19.4788C175.239 -2.60312 215.83 -5.54717 251.828 12.3409C266.783 19.7617 279.502 30.0642 288.964 42.0898H420.34C425.848 42.0898 431.157 44.2906 435.068 48.192L793.877 407.003C802.039 415.146 802.04 428.345 793.896 436.469Z" />
            </svg>
          </div>
          Tags
        </li>
        <li [class.active]="tab === 7" (click)="tabChange(7)">
          <div class="icon">
            <svg viewBox="0 0 432 245" fill="none" width="3rem">
              <path
                d="M0 131.8C0 129.1 0 126.9 0 124.2C1.5 124.2 2.8 124.2 4.1 124.2C33.3 124.2 62.6 124.2 91.8 124.3C93.9 124.3 96.4 125.3 98 126.7C136 161.4 174 196.2 211.9 231C213.1 232.1 214.3 233.2 215.7 234.5C222.8 228 229.7 221.7 236.5 215.4C268.7 185.8 301 156.3 333.2 126.7C335.2 124.9 337.1 124.1 339.8 124.1C368.9 124.2 398 124.2 427.2 124.2C428.5 124.2 429.9 124.2 431.5 124.2C431.5 126.8 431.5 129 431.5 131.8C430.1 131.8 428.7 131.8 427.3 131.8C399.2 131.8 371.1 131.8 342.9 131.7C340.2 131.7 338.3 132.5 336.3 134.3C296.9 170.5 257.5 206.6 218.1 242.8C217.5 243.4 216.8 243.9 215.8 244.8C214.5 243.7 213.2 242.6 211.9 241.4C173 205.8 134.2 170.2 95.3 134.5C93.1 132.5 90.9 131.7 88 131.7C60.4 131.8 32.8 131.8 5.1 131.8C3.6 131.8 2 131.8 0 131.8Z" />
              <path
                d="M0 58.7C0 56.3 0 54.1 0 51.3C1.5 51.3 3 51.3 4.4 51.3C28.9 51.3 53.4 51.3 77.9 51.4C80.6 51.4 82.2 50.5 83.6 48.3C93.6 33.1 103.9 18 113.9 2.69998C115.3 0.599982 116.7 0 119.1 0C183.5 0.1 247.8 0.1 312.2 0C314.8 0 316.2 0.799994 317.6 2.89999C327.6 18.1 337.9 33.2 347.9 48.5C349.3 50.6 350.8 51.4 353.4 51.4C377.9 51.3 402.4 51.3 426.9 51.3C428.4 51.3 429.8 51.3 431.5 51.3C431.5 53.9 431.5 56.1 431.5 58.9C430.3 58.9 429.1 58.9 427.9 58.9C401.7 58.9 375.4 58.9 349.2 59C346.6 59 345.2 58.1 343.8 56C333.7 40.8 323.5 25.7 313.5 10.4C312.2 8.39999 310.7 7.69998 308.3 7.69998C246.6 7.79998 184.8 7.79998 123.1 7.69998C120.6 7.69998 119.3 8.59998 118 10.6C107.9 25.8 97.8 41 87.6 56.1C86.7 57.4 84.8 58.9 83.4 58.9C56.2 59.1 28.9 59 1.7 59C1.2 58.9 0.8 58.8 0 58.7Z" />
              <path
                d="M293.5 38.2002C293.5 40.7002 293.5 42.9002 293.5 45.4002C241.6 45.4002 189.9 45.4002 137.9 45.4002C137.9 43.1002 137.9 40.8002 137.9 38.2002C189.6 38.2002 241.4 38.2002 293.5 38.2002Z" />
              <path
                d="M0 95.3004C0 92.8004 0 90.5004 0 87.9004C24.9 87.9004 49.6 87.9004 74.6 87.9004C74.6 90.4004 74.6 92.7004 74.6 95.3004C49.7 95.3004 25 95.3004 0 95.3004Z" />
              <path
                d="M431.6 87.9004C431.6 90.4004 431.6 92.7004 431.6 95.2004C406.7 95.2004 381.9 95.2004 356.9 95.2004C356.9 92.8004 356.9 90.5004 356.9 87.9004C381.7 87.9004 406.4 87.9004 431.6 87.9004Z" />
              <path
                d="M301.9 94.3002C304.1 98.1002 306.2 101.6 308.4 105.4C301.8 106.7 301.8 106.7 298.9 101.8C298 100.3 297.2 98.7002 296 97.4002C295 96.4002 293.4 95.8002 291.4 94.6002C291.4 99.0002 291.4 102.2 291.4 105.6C289.1 105.6 287.2 105.6 285.1 105.6C285.1 96.2002 285.1 87.0002 285.1 76.7002C290.2 77.0002 295.3 76.9002 300.2 77.6002C303.4 78.0002 305.9 80.2002 306.5 83.7002C307.1 87.4002 306.7 90.7002 303.3 93.0002C302.8 93.6002 302.3 94.0002 301.9 94.3002ZM291.6 91.4002C294.8 90.0002 297.4 89.2002 299.6 87.8002C300.1 87.5002 299.8 84.5002 299.2 84.2002C297 83.1002 294.4 82.6002 291.6 81.8002C291.6 85.2002 291.6 87.5002 291.6 91.4002Z" />
              <path
                d="M199.3 177.7C202.5 177.7 205.7 177.9 208.9 177.6C210.1 177.5 211.7 176.3 212.2 175.2C213.5 172.3 214.3 169.1 216.1 165.9C217.1 168.8 218.1 171.8 218.9 174.7C219.5 177 220.7 177.9 223.1 177.8C226.1 177.6 229.2 177.8 232.5 178.5C229.8 180.4 227 182.2 224.6 184.4C223.8 185.1 223.1 186.9 223.4 188C224.1 191.2 225.4 194.4 225.8 198.1C223.8 196.6 221.5 195.4 219.7 193.7C217 191.2 214.7 190.7 211.8 193.6C210 195.4 207.7 196.7 205 197.7C205.9 194.9 206.5 192 207.7 189.3C209 186.5 208.2 185 205.7 183.6C203.3 182.1 201.1 180.3 198.8 178.6C199 178.3 199.1 178 199.3 177.7Z" />
              <path
                d="M162.5 77.2996C164.7 77.2996 166.4 77.2996 168.7 77.2996C168.7 81.8996 168.7 86.2996 168.7 90.6996C168.7 92.6996 168.7 94.6996 169 96.6996C169.4 99.5996 171.3 101.1 174.2 100.9C177.1 100.7 178.9 99.0996 179 96.1996C179.1 90.0996 179 83.9996 179 77.3996C181.2 77.2996 183.1 77.1996 186 77.0996C185.6 84.8996 185.8 92.4996 184.7 99.8996C184 104.8 178.8 107.1 172.4 106.5C166.7 106 162.7 103.1 162.5 98.1996C162.2 91.2996 162.5 84.4996 162.5 77.2996Z" />
              <path
                d="M252.7 82.5004C252.7 84.7004 252.7 86.2004 252.7 88.2004C256.3 88.2004 260 88.2004 263.8 88.2004C263.8 90.2004 263.8 91.6004 263.8 93.5004C260.1 93.5004 256.6 93.5004 252.8 93.5004C252.8 95.9004 252.8 98.0004 252.8 100.5C257.3 100.5 261.8 100.5 266.3 100.5C266.3 102.5 266.3 104.1 266.3 106C260.1 106 254.2 106.1 248.2 105.9C247.5 105.9 246.3 104.9 246.2 104.4C246.1 95.5004 246.1 86.5004 246.1 77.4004C252.7 77.4004 258.7 77.4004 265.2 77.4004C265.3 79.0004 265.4 80.5004 265.5 82.5004C261.2 82.5004 257.1 82.5004 252.7 82.5004Z" />
              <path
                d="M212.1 96.8003C212.1 99.7003 212.1 102.6 212.1 105.8C209.9 105.8 208.1 105.8 205.6 105.8C205.6 101.8 205.6 97.9003 205.6 93.9003C205.6 89.3003 205.5 84.7003 205.7 80.0003C205.7 79.0003 207 77.3003 207.7 77.3003C212 77.2003 216.5 77.0003 220.7 77.7003C225.5 78.6003 227.5 81.8003 227.5 86.6003C227.5 91.3003 225.2 94.4003 220.5 95.5003C218 96.2003 215.3 96.3003 212.1 96.8003ZM211.5 90.7003C215.4 90.6003 218.6 91.4003 220.3 88.4003C220.9 87.3003 220.6 84.5003 219.8 84.1003C217.8 83.1003 215.4 82.9003 213.2 82.4003C212.7 85.0003 212.2 87.5003 211.5 90.7003Z" />
              <path
                d="M142.5 78.6004C141.9 80.4004 141.4 81.7004 140.9 83.1004C138.2 82.8004 135.6 82.3004 133.1 82.4004C132.1 82.4004 130.6 83.5004 130.4 84.3004C130.2 85.1004 131.2 86.6004 132.1 87.1004C134.1 88.3004 136.5 88.9004 138.6 89.9004C142.9 91.9004 144.4 94.8004 143.8 99.6004C143.3 103.2 140.7 105.6 136.3 106.2C131.8 106.8 127.4 106.7 123.1 104.3C123.7 102.5 124.2 101.1 124.6 99.6004C127.1 100.1 129.3 100.7 131.5 100.8C133.6 100.9 136.7 101.5 136.8 98.4004C136.9 97.1004 134.5 95.4004 132.9 94.3004C131.4 93.3004 129.4 92.9004 127.8 92.1004C124.7 90.5004 123.3 88.0004 123.5 84.5004C123.7 81.0004 125.6 78.6004 128.8 77.4004C133.3 75.8004 137.8 76.2004 142.5 78.6004Z" />
              <path
                d="M289 133.7C290.7 136.7 292.1 139.1 293.7 141.8C290.2 142.7 288 142.3 286.5 139C285.6 137.1 284.8 134.5 281.5 134.6C281.4 137.1 281.2 139.4 281.1 141.9C279.6 141.9 278.3 141.9 276.4 141.9C276.4 135.6 276.3 129.3 276.5 123C276.5 122.3 277.7 121.2 278.5 121.1C280.3 120.8 282.2 120.8 284.1 120.9C287.5 121 290.8 121.7 292 125.3C293.2 128.8 292.4 131.8 289 133.7ZM281.4 131.6C283.8 130.6 285.6 130 287.1 129C287.5 128.8 287.3 126.6 286.9 126.4C285.3 125.6 283.5 125.2 281.4 124.6C281.4 127.2 281.4 128.7 281.4 131.6Z" />
              <path
                d="M181.1 138.3C181.1 139.9 181.1 140.9 181.1 142.1C176.2 142.1 171.6 142.1 166.6 142.1C166.6 135.3 166.6 128.5 166.6 121.5C171.1 121.5 175.5 121.5 180.4 121.5C180.4 122.6 180.5 123.7 180.6 125.3C177.4 125.3 174.6 125.3 171.6 125.3C171.5 126.8 171.5 127.8 171.4 129.3C174.2 129.3 176.7 129.3 179.6 129.3C179.7 130.7 179.7 131.8 179.8 133.1C177 133.2 174.4 133.3 171.6 133.5C171.6 135.1 171.6 136.6 171.6 138.4C174.7 138.3 177.7 138.3 181.1 138.3Z" />
              <path
                d="M253.3 125.1C253.3 126.8 253.3 127.8 253.3 129.2C255.9 129.2 258.3 129.2 261.1 129.2C261.3 130.5 261.4 131.5 261.6 133C258.8 133 256.2 133 253.4 133C253.4 134.9 253.4 136.3 253.4 138.2C256.6 138.2 259.7 138.2 263.1 138.2C263.1 139.7 263.1 140.8 263.1 142C258.2 142 253.5 142 248.6 142C248.6 135.1 248.6 128.4 248.6 121.4C253 121.4 257.4 121.4 262.3 121.4C262.4 122.4 262.4 123.5 262.5 125.1C259.4 125.1 256.6 125.1 253.3 125.1Z" />
              <path
                d="M137.3 142C138.1 139.9 138.5 138.9 138.9 137.8C140.8 138 142.5 138.5 144.1 138.4C145.4 138.3 146.6 137.4 147.9 136.9C147 135.9 146.3 134.6 145.2 133.9C144 133.1 142.1 133.1 141.2 132C139.8 130.3 138 128.1 138.2 126.2C138.4 124.4 140.6 121.8 142.4 121.3C145.3 120.5 148.5 121.1 152.2 121.1C151.5 123.3 151.2 124.3 150.8 125.3C148.8 125.1 147 124.7 145.2 124.8C144.4 124.8 143.5 125.7 143.1 126.4C142.9 126.8 143.8 128 144.4 128.3C145.9 129.1 147.6 129.7 149.2 130.4C152.3 131.7 153.2 134.2 152.9 137.4C152.5 140.3 150.7 142 148 142.1C144.5 142.5 141.2 142.2 137.3 142Z" />
              <path
                d="M209.1 142.1C203.9 142.1 199.5 142.1 194.8 142.1C194.8 135.1 194.8 128.4 194.8 121.4C196.3 121.4 197.6 121.4 199.3 121.4C199.3 127 199.3 132.4 199.3 137.3C202.3 140 207.8 135.5 209.1 142.1Z" />
              <path
                d="M226.2 138.3C229.6 138.3 232.3 138.3 235.3 138.3C235.4 139.6 235.5 140.7 235.6 142C230.9 142 226.5 142 221.8 142C221.8 135.2 221.8 128.4 221.8 121.4C223.2 121.4 224.5 121.4 226.2 121.4C226.2 126.9 226.2 132.3 226.2 138.3Z" />
            </svg>
          </div>
          Super Seller
        </li>
        <li *ngIf="tab >= 8 && (userInfo?.level ?? 1) >= 5" [class.active]="tab === 9" (click)="tabChange(9)">
          <div class="icon">
            <svg viewBox="0 0 678 625" fill="none" width="2rem">
              <path
                d="M670 420C667.5 407.5 652.5 397.5 640 402.5C627.5 405 620 402.5 620 400C617.5 397.5 620 390.001 630 380.001C640 370.001 637.5 355 630 345C610 325 585 310 557.5 302.5C545 300 530 307.5 527.5 320C525 332.5 517.5 337.5 515 337.5C512.5 337.5 507.5 332.5 502.5 320C497.5 307.5 485 300 472.5 302.5C445 310 420 325 400 345C390 355 390 370.001 400 380.001C410 390.001 410 397.5 410 400C410 402.5 402.5 405 390 402.5C377.5 400 362.5 407.5 360 420C357.5 435 355 450 355 462.5C355 475 357.5 490.001 360 505.001C362.5 517.501 377.5 527.5 390 522.5C402.5 520 410 522.5 410 525C412.5 527.5 410 535 400 545C390 555 392.5 570.001 400 580.001C420 600.001 445 615 472.5 622.5C485 625 500 617.501 502.5 605.001C505 592.501 512.5 587.501 515 587.501C517.5 587.501 522.5 592.501 527.5 605.001C530 615.001 540 622.5 552.5 622.5C555 622.5 557.5 622.5 560 622.5C587.5 615 612.5 600.001 632.5 580.001C642.5 570.001 642.5 555 632.5 545C622.5 535 622.5 527.5 622.5 525C622.5 522.5 630 520 642.5 522.5C655 525 670 517.501 672.5 505.001C675 490.001 677.5 475 677.5 462.5C677.5 450 672.5 435 670 420ZM512.5 525C477.5 525 450 497.5 450 462.5C450 427.5 477.5 400 512.5 400C547.5 400 575 427.5 575 462.5C575 497.5 547.5 525 512.5 525Z"
                fill="black" />
              <path
                d="M300 462.5C300 345 395 250 512.5 250C565 250 612.5 270 650 300V125C650 55 595 0 525 0H125C55 0 0 55 0 125V600C0 610 5 617.5 15 622.5C17.5 625 22.5 625 25 625C30 625 37.5 622.5 42.5 620C117.5 555 207.5 512.5 302.5 490C300 480 300 472.5 300 462.5ZM200 175H350C365 175 375 185 375 200C375 215 365 225 350 225H200C185 225 175 215 175 200C175 185 185 175 200 175ZM275 325H200C185 325 175 315 175 300C175 285 185 275 200 275H275C290 275 300 285 300 300C300 315 290 325 275 325Z"
                fill="black" />
            </svg>
          </div>
          Chat Settings
        </li>
        <li *ngIf="tab >= 8 && (userInfo?.level ?? 1) >= 5" [class.active]="tab === 10" (click)="tabChange(10)">
          <div class="icon">
            <svg viewBox="0 0 432 292" fill="none" width="3rem">
              <path
                d="M0 178.8C0 176.1 0 173.9 0 171.2C1.5 171.2 2.8 171.2 4.1 171.2C33.3 171.2 62.6 171.2 91.8 171.3C93.9 171.3 96.4 172.3 98 173.7C136 208.4 174 243.2 211.9 278C213.1 279.1 214.3 280.2 215.7 281.5C222.8 275 229.7 268.7 236.5 262.4C268.7 232.8 301 203.3 333.2 173.7C335.2 171.9 337.1 171.1 339.8 171.1C368.9 171.2 398 171.2 427.2 171.2C428.5 171.2 429.9 171.2 431.5 171.2C431.5 173.8 431.5 176 431.5 178.8C430.1 178.8 428.7 178.8 427.3 178.8C399.2 178.8 371.1 178.8 342.9 178.7C340.2 178.7 338.3 179.5 336.3 181.3C296.9 217.5 257.5 253.6 218.1 289.8C217.5 290.4 216.8 290.9 215.8 291.8C214.5 290.7 213.2 289.6 211.9 288.4C173 252.8 134.2 217.2 95.3 181.5C93.1 179.5 90.9 178.7 88 178.7C60.4 178.8 32.8 178.8 5.1 178.8C3.6 178.8 2 178.8 0 178.8Z" />
              <path
                d="M0 105.7C0 103.3 0 101.1 0 98.3C1.5 98.3 3 98.3 4.4 98.3C28.9 98.3 53.4 98.3 77.9 98.4C80.6 98.4 82.2 97.5 83.6 95.3C93.6 80.1 103.9 65 113.9 49.7C115.3 47.6 116.7 47 119.1 47C183.5 47.1 247.8 47.1 312.2 47C314.8 47 316.2 47.8 317.6 49.9C327.6 65.1 337.9 80.2 347.9 95.5C349.3 97.6 350.8 98.4 353.4 98.4C377.9 98.3 402.4 98.3 426.9 98.3C428.4 98.3 429.8 98.3 431.5 98.3C431.5 100.9 431.5 103.1 431.5 105.9C430.3 105.9 429.1 105.9 427.9 105.9C401.7 105.9 375.4 105.9 349.2 106C346.6 106 345.2 105.1 343.8 103C333.7 87.8 323.5 72.7 313.5 57.4C312.2 55.4 310.7 54.7 308.3 54.7C246.6 54.8 184.8 54.8 123.1 54.7C120.6 54.7 119.3 55.6 118 57.6C107.9 72.8 97.8 88 87.6 103.1C86.7 104.4 84.8 105.9 83.4 105.9C56.2 106.1 28.9 106 1.7 106C1.2 105.9 0.8 105.8 0 105.7Z" />
              <path
                d="M0 142.3C0 139.8 0 137.5 0 134.9C24.9 134.9 49.6 134.9 74.6 134.9C74.6 137.4 74.6 139.7 74.6 142.3C49.7 142.3 25 142.3 0 142.3Z" />
              <path
                d="M431.6 134.9C431.6 137.4 431.6 139.7 431.6 142.2C406.7 142.2 381.9 142.2 356.9 142.2C356.9 139.8 356.9 137.5 356.9 134.9C381.7 134.9 406.4 134.9 431.6 134.9Z" />
              <path
                d="M301.9 141.3C304.1 145.1 306.2 148.6 308.4 152.4C301.8 153.7 301.8 153.7 298.9 148.8C298 147.3 297.2 145.7 296 144.4C295 143.4 293.4 142.8 291.4 141.6C291.4 146 291.4 149.2 291.4 152.6C289.1 152.6 287.2 152.6 285.1 152.6C285.1 143.2 285.1 134 285.1 123.7C290.2 124 295.3 123.9 300.2 124.6C303.4 125 305.9 127.2 306.5 130.7C307.1 134.4 306.7 137.7 303.3 140C302.8 140.6 302.3 141 301.9 141.3ZM291.6 138.4C294.8 137 297.4 136.2 299.6 134.8C300.1 134.5 299.8 131.5 299.2 131.2C297 130.1 294.4 129.6 291.6 128.8C291.6 132.2 291.6 134.5 291.6 138.4Z" />
              <path
                d="M199.3 224.7C202.5 224.7 205.7 224.9 208.9 224.6C210.1 224.5 211.7 223.3 212.2 222.2C213.5 219.3 214.3 216.1 216.1 212.9C217.1 215.8 218.1 218.8 218.9 221.7C219.5 224 220.7 224.9 223.1 224.8C226.1 224.6 229.2 224.8 232.5 225.5C229.8 227.4 227 229.2 224.6 231.4C223.8 232.1 223.1 233.9 223.4 235C224.1 238.2 225.4 241.4 225.8 245.1C223.8 243.6 221.5 242.4 219.7 240.7C217 238.2 214.7 237.7 211.8 240.6C210 242.4 207.7 243.7 205 244.7C205.9 241.9 206.5 239 207.7 236.3C209 233.5 208.2 232 205.7 230.6C203.3 229.1 201.1 227.3 198.8 225.6C199 225.3 199.1 225 199.3 224.7Z" />
              <path
                d="M162.5 124.3C164.7 124.3 166.4 124.3 168.7 124.3C168.7 128.9 168.7 133.3 168.7 137.7C168.7 139.7 168.7 141.7 169 143.7C169.4 146.6 171.3 148.1 174.2 147.9C177.1 147.7 178.9 146.1 179 143.2C179.1 137.1 179 131 179 124.4C181.2 124.3 183.1 124.2 186 124.1C185.6 131.9 185.8 139.5 184.7 146.9C184 151.8 178.8 154.1 172.4 153.5C166.7 153 162.7 150.1 162.5 145.2C162.2 138.3 162.5 131.5 162.5 124.3Z" />
              <path
                d="M252.7 129.5C252.7 131.7 252.7 133.2 252.7 135.2C256.3 135.2 260 135.2 263.8 135.2C263.8 137.2 263.8 138.6 263.8 140.5C260.1 140.5 256.6 140.5 252.8 140.5C252.8 142.9 252.8 145 252.8 147.5C257.3 147.5 261.8 147.5 266.3 147.5C266.3 149.5 266.3 151.1 266.3 153C260.1 153 254.2 153.1 248.2 152.9C247.5 152.9 246.3 151.9 246.2 151.4C246.1 142.5 246.1 133.5 246.1 124.4C252.7 124.4 258.7 124.4 265.2 124.4C265.3 126 265.4 127.5 265.5 129.5C261.2 129.5 257.1 129.5 252.7 129.5Z" />
              <path
                d="M212.1 143.8C212.1 146.7 212.1 149.6 212.1 152.8C209.9 152.8 208.1 152.8 205.6 152.8C205.6 148.8 205.6 144.9 205.6 140.9C205.6 136.3 205.5 131.7 205.7 127C205.7 126 207 124.3 207.7 124.3C212 124.2 216.5 124 220.7 124.7C225.5 125.6 227.5 128.8 227.5 133.6C227.5 138.3 225.2 141.4 220.5 142.5C218 143.2 215.3 143.3 212.1 143.8ZM211.5 137.7C215.4 137.6 218.6 138.4 220.3 135.4C220.9 134.3 220.6 131.5 219.8 131.1C217.8 130.1 215.4 129.9 213.2 129.4C212.7 132 212.2 134.5 211.5 137.7Z" />
              <path
                d="M142.5 125.6C141.9 127.4 141.4 128.7 140.9 130.1C138.2 129.8 135.6 129.3 133.1 129.4C132.1 129.4 130.6 130.5 130.4 131.3C130.2 132.1 131.2 133.6 132.1 134.1C134.1 135.3 136.5 135.9 138.6 136.9C142.9 138.9 144.4 141.8 143.8 146.6C143.3 150.2 140.7 152.6 136.3 153.2C131.8 153.8 127.4 153.7 123.1 151.3C123.7 149.5 124.2 148.1 124.6 146.6C127.1 147.1 129.3 147.7 131.5 147.8C133.6 147.9 136.7 148.5 136.8 145.4C136.9 144.1 134.5 142.4 132.9 141.3C131.4 140.3 129.4 139.9 127.8 139.1C124.7 137.5 123.3 135 123.5 131.5C123.7 128 125.6 125.6 128.8 124.4C133.3 122.8 137.8 123.2 142.5 125.6Z" />
              <path
                d="M289 180.7C290.7 183.7 292.1 186.1 293.7 188.8C290.2 189.7 288 189.3 286.5 186C285.6 184.1 284.8 181.5 281.5 181.6C281.4 184.1 281.2 186.4 281.1 188.9C279.6 188.9 278.3 188.9 276.4 188.9C276.4 182.6 276.3 176.3 276.5 170C276.5 169.3 277.7 168.2 278.5 168.1C280.3 167.8 282.2 167.8 284.1 167.9C287.5 168 290.8 168.7 292 172.3C293.2 175.8 292.4 178.8 289 180.7ZM281.4 178.6C283.8 177.6 285.6 177 287.1 176C287.5 175.8 287.3 173.6 286.9 173.4C285.3 172.6 283.5 172.2 281.4 171.6C281.4 174.2 281.4 175.7 281.4 178.6Z" />
              <path
                d="M181.1 185.3C181.1 186.9 181.1 187.9 181.1 189.1C176.2 189.1 171.6 189.1 166.6 189.1C166.6 182.3 166.6 175.5 166.6 168.5C171.1 168.5 175.5 168.5 180.4 168.5C180.4 169.6 180.5 170.7 180.6 172.3C177.4 172.3 174.6 172.3 171.6 172.3C171.5 173.8 171.5 174.8 171.4 176.3C174.2 176.3 176.7 176.3 179.6 176.3C179.7 177.7 179.7 178.8 179.8 180.1C177 180.2 174.4 180.3 171.6 180.5C171.6 182.1 171.6 183.6 171.6 185.4C174.7 185.3 177.7 185.3 181.1 185.3Z" />
              <path
                d="M253.3 172.1C253.3 173.8 253.3 174.8 253.3 176.2C255.9 176.2 258.3 176.2 261.1 176.2C261.3 177.5 261.4 178.5 261.6 180C258.8 180 256.2 180 253.4 180C253.4 181.9 253.4 183.3 253.4 185.2C256.6 185.2 259.7 185.2 263.1 185.2C263.1 186.7 263.1 187.8 263.1 189C258.2 189 253.5 189 248.6 189C248.6 182.1 248.6 175.4 248.6 168.4C253 168.4 257.4 168.4 262.3 168.4C262.4 169.4 262.4 170.5 262.5 172.1C259.4 172.1 256.6 172.1 253.3 172.1Z" />
              <path
                d="M137.3 189C138.1 186.9 138.5 185.9 138.9 184.8C140.8 185 142.5 185.5 144.1 185.4C145.4 185.3 146.6 184.4 147.9 183.9C147 182.9 146.3 181.6 145.2 180.9C144 180.1 142.1 180.1 141.2 179C139.8 177.3 138 175.1 138.2 173.2C138.4 171.4 140.6 168.8 142.4 168.3C145.3 167.5 148.5 168.1 152.2 168.1C151.5 170.3 151.2 171.3 150.8 172.3C148.8 172.1 147 171.7 145.2 171.8C144.4 171.8 143.5 172.7 143.1 173.4C142.9 173.8 143.8 175 144.4 175.3C145.9 176.1 147.6 176.7 149.2 177.4C152.3 178.7 153.2 181.2 152.9 184.4C152.5 187.3 150.7 189 148 189.1C144.5 189.5 141.2 189.2 137.3 189Z" />
              <path
                d="M209.1 189.1C203.9 189.1 199.5 189.1 194.8 189.1C194.8 182.1 194.8 175.4 194.8 168.4C196.3 168.4 197.6 168.4 199.3 168.4C199.3 174 199.3 179.4 199.3 184.3C202.3 187 207.8 182.5 209.1 189.1Z" />
              <path
                d="M226.2 185.3C229.6 185.3 232.3 185.3 235.3 185.3C235.4 186.6 235.5 187.7 235.6 189C230.9 189 226.5 189 221.8 189C221.8 182.2 221.8 175.4 221.8 168.4C223.2 168.4 224.5 168.4 226.2 168.4C226.2 173.9 226.2 179.3 226.2 185.3Z" />
              <path
                d="M266.581 36.7584C265.775 32.8638 260.938 29.7481 256.907 31.306C252.876 32.0849 250.457 31.306 250.457 30.527C249.651 29.7481 250.457 27.4114 253.682 24.2957C256.907 21.18 256.101 16.5065 253.682 13.3908C247.233 7.1595 239.171 2.486 230.302 0.149242C226.271 -0.629676 221.434 1.70707 220.628 5.60166C219.822 9.49625 217.403 11.0541 216.597 11.0541C215.791 11.0541 214.178 9.49625 212.566 5.60166C210.953 1.70707 206.922 -0.629676 202.891 0.149242C194.023 2.486 185.961 7.1595 179.512 13.3908C176.287 16.5065 176.287 21.18 179.512 24.2957C182.736 27.4114 182.736 29.7481 182.736 30.527C182.736 31.306 180.318 32.0849 176.287 31.306C172.256 30.5271 167.419 32.8638 166.612 36.7584C165.806 41.4319 165 46.1054 165 50C165 53.8946 165.806 58.5681 166.612 63.2416C167.419 67.1362 172.256 70.2519 176.287 68.694C180.318 67.9151 182.736 68.694 182.736 69.473C183.543 70.2519 182.736 72.5886 179.512 75.7043C176.287 78.82 177.093 83.4935 179.512 86.6092C185.961 92.8405 194.023 97.514 202.891 99.8508C206.922 100.63 211.76 98.2929 212.566 94.3983C213.372 90.5038 215.791 88.9459 216.597 88.9459C217.403 88.9459 219.015 90.5038 220.628 94.3983C221.434 97.514 224.659 99.8508 228.69 99.8508C229.496 99.8508 230.302 99.8508 231.109 99.8508C239.977 97.514 248.039 92.8405 254.488 86.6092C257.713 83.4935 257.713 78.82 254.488 75.7043C251.264 72.5886 251.264 70.2519 251.264 69.473C251.264 68.694 253.682 67.9151 257.713 68.694C261.744 69.473 266.581 67.1362 267.388 63.2416C268.194 58.5681 269 53.8946 269 50C269 46.1054 267.388 41.4319 266.581 36.7584ZM215.791 69.473C204.504 69.473 195.636 60.9049 195.636 50C195.636 39.0951 204.504 30.527 215.791 30.527C227.078 30.527 235.946 39.0951 235.946 50C235.946 60.9049 227.078 69.473 215.791 69.473Z" />
            </svg>
          </div>
          Super Seller Settings
        </li>
        <li *ngIf="tab >= 8 && (userInfo?.level ?? 1) >= 5" [class.active]="tab === 11" (click)="tabChange(11)">
          <div class="icon">
            <svg viewBox="0 0 784 800" fill="none" width="2rem">
              <path
                d="M672.069 611.234C723.326 546.891 754.128 465.247 754.105 376.675C754.128 272.791 711.872 178.347 643.78 110.325C575.739 42.2203 481.295 -0.0249889 377.417 1.10898e-05C273.533 -0.0249889 179.097 42.2203 111.062 110.325C42.9624 178.347 0.712412 272.791 0.73585 376.675C0.712412 480.547 42.9624 574.991 111.062 643.025C179.097 711.13 273.534 753.375 377.419 753.35C457.025 753.375 531.031 728.491 591.92 686.256L705.681 800L783.264 722.417L672.069 611.234ZM583.419 582.681C530.566 635.452 458.001 667.98 377.417 668.003C296.833 667.98 224.269 635.452 171.409 582.681C118.622 529.816 86.1046 457.258 86.0812 376.675C86.1046 296.091 118.622 223.533 171.409 170.669C224.269 117.888 296.833 85.3703 377.417 85.3469C458.001 85.3703 530.564 117.888 583.419 170.669C636.217 223.533 668.734 296.092 668.758 376.675C668.734 457.259 636.217 529.816 583.419 582.681Z" />
              <path
                d="M235.634 367.351L226.734 366.114C203.987 362.898 195.825 354.993 195.825 343.371C195.825 330.264 205.219 320.868 222.281 320.868C236.372 320.868 248.981 325.073 262.584 333.978C263.817 334.717 265.056 334.467 266.044 333.228L277.914 314.94C278.903 313.451 278.653 312.464 277.414 311.475C264.067 301.343 244.041 294.662 223.025 294.662C188.406 294.662 166.153 314.939 166.153 345.35C166.153 373.282 184.453 388.868 216.841 393.309L225.741 394.546C248.983 397.762 256.4 405.679 256.4 417.789C256.4 431.886 244.78 442.018 224.751 442.018C205.964 442.018 189.889 432.875 179.012 424.218C178.025 423.231 176.542 423.231 175.553 424.468L160.223 442.268C159.236 443.506 159.73 444.982 160.717 445.984C173.82 458.342 197.8 468.225 222.531 468.225C264.311 468.225 285.826 445.984 285.826 416.062C285.826 387.128 268.019 371.806 235.634 367.351Z" />
              <path
                d="M422.572 297.378H317.247C315.764 297.378 314.776 298.365 314.776 299.854V463.034C314.776 464.523 315.764 465.511 317.247 465.511H422.572C424.061 465.511 425.048 464.523 425.048 463.034V441.781C425.048 440.294 424.061 439.304 422.572 439.304H345.434L343.951 437.815V395.297L345.434 393.809H410.456C411.945 393.809 412.934 392.82 412.934 391.331V370.067C412.934 368.59 411.945 367.603 410.456 367.603H345.434L343.951 366.114V325.073L345.434 323.597H422.572C424.061 323.597 425.048 322.597 425.048 321.12V299.854C425.048 298.365 424.061 297.378 422.572 297.378Z" />
              <path
                d="M514.575 294.662C485.647 294.662 463.889 308.511 455.239 335.215C451.773 345.598 450.786 354.993 450.786 381.448C450.786 407.904 451.773 417.298 455.239 427.681C463.889 454.387 485.648 468.223 514.575 468.223C543.758 468.223 565.498 454.387 574.167 427.681C577.62 417.298 578.62 407.904 578.62 381.448C578.62 354.992 577.62 345.598 574.167 335.215C565.498 308.511 543.756 294.662 514.575 294.662ZM545.972 420.015C541.279 433.612 531.398 442.018 514.573 442.018C498.011 442.018 488.117 433.612 483.42 420.015C481.443 413.836 480.454 405.179 480.454 381.45C480.454 357.457 481.443 349.053 483.42 342.871C488.118 329.275 498.012 320.868 514.573 320.868C531.398 320.868 541.279 329.275 545.972 342.871C547.948 349.051 548.947 357.457 548.947 381.45C548.948 405.179 547.948 413.834 545.972 420.015Z" />
            </svg>
          </div>
          SEO
        </li>
      </ul>
    </div>
    <div class="content" [class.full-height]="tab === 0">
      @if(tab === 0){
      <app-advanced-settings-intro></app-advanced-settings-intro>
      } @else if(tab === 1) {
      <div class="content__title">Edit Profile</div>
      <div class="content__box">
        <div class="row">
          <div class="col-md-6">
            <label class="input">
              <input class="input__field" type="text" placeholder=" " [(ngModel)]="charName" />
              <span class="input__label">Character Name</span>
            </label>
          </div>
          <div class="col-md-6">
            <label class="input">
              <div class="position-relative" style="z-index: 60">
                <div value="" (clickOutside)="showAvatarDropdown = false"
                  (click)="showAvatarDropdown = !showAvatarDropdown">
                  @if(selectedAvatar){
                  <div class="d-flex w-100 mx-1 justify-content-between" style="background-color: var(--white)">
                    <span>{{ selectedAvatar.title }}</span>
                    <span><img style="max-height: 3rem" class="shadow rounded"
                        [src]="compressedImagePath + selectedAvatar.image" /></span>
                  </div>
                  }@else{
                  <div class="d-flex flex-column justify-content-center align-items-center">
                    <span class="pt-2"> Change Character Image <i class="fa fa-chevron-down"></i> </span>
                  </div>
                  }
                </div>
                <div class="d-flex flex-column position-absolute p-2 shadow rounded-sm"
                  style="top: 100%; left: 0; background: var(--white)" *ngIf="showAvatarDropdown">
                  <div *ngFor="let avatar of ROLES" (click)="selectedAvatar = avatar; onCharImageChange()" class="my-1">
                    <div class="d-flex w-100 mx-1 justify-content-between" style="background-color: var(--white)">
                      <span>{{ avatar.title }}</span>
                      <span><img style="max-height: 3rem" class="shadow rounded"
                          [src]="compressedImagePath + avatar.image" /></span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <span class="input__label">Character Image</span> -->
            </label>
            <!-- <div class="d-flex" style="gap: 1em;">
              <label class="input">
                <input class="input__field" type="file" placeholder=" " (change)="onCharImageChange($event)"
                  accept="image/png, image/jpg, image/jpeg" />
                <span class="input__label">Character Image</span>
              </label>

            </div> -->
          </div>
        </div>
        <ng-container *ngIf="charImage.preview">
          <div class="d-flex justify-content-center flex-column my-3">
            <label style="color: var(--primary)"><strong>Character Image Preview</strong></label>
            <img src="{{ charImage.preview }}" class="char-img-preview" alt="" />
          </div>
          <label class="input">
            <select class="input__field" [(ngModel)]="charImage.default">
              <option [value]="true">Character Image</option>
              <option [value]="false">Avatar</option>
            </select>
            <span class="input__label">Default Character Image</span>
          </label>
        </ng-container>
        <label class="input">
          <input class="input__field" type="text" minlength="6" maxlength="6"
            [ngStyle]="{ 'background-color': numberOfDayForPostalCodeChange ? '#eee' : 'inherit' }"
            [disabled]="numberOfDayForPostalCodeChange ? true : false" [(ngModel)]="postalCode"
            (ngModelChange)="filterSubregions()" />
          <span class="input__label">Postal Code {{ numberOfDayForPostalCodeChange ? "- (" +
            numberOfDayForPostalCodeChange + " days)" : "" }}</span>
        </label>
        <label class="input">
          <textarea class="input__field" type="text" placeholder=" " [(ngModel)]="shortDescription"></textarea>
          <span class="input__label">Short Description</span>
        </label>
        <label class="input">
          <input class="input__field" [disabled]="true" style="background-color: #eee" type="text" placeholder=" "
            [(ngModel)]="selectedMemberRegion" title="Select postal code to change region" />
          <!-- <app-multi-dropdown class="input__field p-0" [disabled]="true" [placeholder]="selectedMemberRegion"  [items]="regionList"   (itemSelected)="onRegionClick($event)"></app-multi-dropdown> -->
          <span class="input__label">Region</span>
        </label>
        <label class="input">
          <select2 class="input__field p-0" [data]="certifiedSelect" [multiple]="true" displaySearchStatus="always"
            (update)="updateCertificate($event)" ngDefaultControl [value]="certifiedValue"> </select2>
          <span class="input__label">Certified</span>
        </label>
        <label class="input" *ngIf="roleService.roles?.level?.includes('MEMBER_SHOP_THEME')">
          <select class="input__field" [value]="userInfo?.theme || 'space'" (change)="onThemeChange($event)">
            <option value="space">Space</option>
            <option value="beige">Beige</option>
            <option value="winter">Winter</option>
            <option value="bronze">Bronze</option>
          </select>
          <span class="input__label">Theme</span>
        </label>
        <label class="input">
          <select class="input__field" [(ngModel)]="bgBody" (change)="onBgBodyChange($event)">
            <option [value]="">No Background</option>
            <!-- <option [value]="'bg-1'">Background 1</option> -->
            <option [value]="'bg-2'">Background 2</option>
          </select>
          <span class="input__label">Background Body</span>
        </label>
      </div>
      <button class="my-button-3 d-flex m-auto" (click)="saveProfileInfo()"><i class="fa-solid fa-save"></i>
        Save</button>
      } @else if(tab === -1) {
        <div class="w-100 d-flex justify-content-end">
          <span class="btn btn-sm btn-outline-secondary" style="display: flex;
          gap: .3rem;
          align-items: center;
          
        " routerLink="/rewards">
            Use My {{userInfo.points}}  <img src="../../../../../assets/images/gold-coin.png" style="width: 1.5rem; height: 1.5rem;" />
          </span>
        </div>
      <app-advanced-settings-contribution></app-advanced-settings-contribution>
      <div class="content__box d-flex w-100 justify-content-center">
        <div class="profile-mini">
          <div class="profile-mini__body">
            <!----------------------------------------------------------------------------------->
            <div class="level" [class.fit-height]="openShepherd">
              <div class="title-mobile">Profile</div>
              <img loading="lazy" class="img" src="../../../../../../assets/images/new/badge.png" />
              <div class="phone">
                {{ maskNumber(userInfo?.phone) || "" }}
              </div>
              <div class="all">
                <span> {{ userInfo?.points || 0 }} XP / {{ userInfo?.requirePoints || 0 }} XP</span>
                <div class="diamonds" (click)="openBuyDiamonds()">
                  <div class="diamonds__text">{{ diamonds }}</div>
                  <img loading="lazy" class="diamonds__img" src="../../../../../../assets/images/diamond.png" />
                </div>
              </div>
              <ngb-progressbar [animated]="true" [value]="userInfo?.progressBarValue || 0"
                [striped]="true"></ngb-progressbar>
              <div class="hexagon">{{ userInfo?.level }}</div>
              <!-- <ul [class.open]="openList">
          <li>
            <a>
              <i class="fa-solid fa-clipboard-list"></i>
              <div class="right">
                <span class="text">Forum Posts</span>
                <span class="badge badge-warning">
                  {{ userInfo?.forumPostsCount || 0 }}
                </span>
              </div>
            </a>
          </li>
          <li>
            <a>
              <i class="fa-solid fa-pen-square"></i>
              <div class="right">
                <span class="text">Suggestions</span>
                <span class="badge badge-warning">
                  {{ userInfo?.suggestionsCount || 0 }}
                </span>
              </div>
            </a>
          </li>
          <li>
            <a>
              <i class="fa-solid fa-user"></i>
              <div class="right">
                <span class="text">Referrals</span>
                <span class="badge badge-warning">
                  {{ userInfo?.referralsCount || 0 }}
                </span>
              </div>
            </a>
          </li>
          <li>
            <a>
              <i class="fa-solid fa-heart"></i>
              <div class="right">
                <span class="text">Favorite Products</span>
                <span class="badge badge-warning">
                  {{ userInfo?.favorites?.length || 0 }}
                </span>
              </div>
            </a>
          </li>

        </ul> -->
              <!-- <div class="arrow-down" [class.active]="openList" (click)="openList = !openList">
          <i class="fa-solid fa-caret-down"></i>
        </div> -->
            </div>
          </div>
        </div>
        <!----------------------------------------------------------------------------------->
      </div>

      } @else if(tab === 2) {
      <ng-container *ngIf="userInfo?.isVerified">
        <div class="content__title">Reset Password</div>
        <div class="content__box">
          <label class="input">
            <input class="input__field" type="password" placeholder=" " [(ngModel)]="passcode" />
            <span class="input__label">New Passcode</span>
          </label>
          <label class="input">
            <input class="input__field" type="password" placeholder=" " [(ngModel)]="passcodeConfirm" />
            <span class="input__label">New Passcode Confirmation</span>
          </label>
          <label class="input">
            <button class="btn btn-dark btn-otp" (click)="handleSendOTP()">
              Send OTP<span *ngIf="delaySendOTP > 0" class="ml-2">({{ delaySendOTP }})</span>
            </button>
            <input class="input__field" placeholder=" " type="number" minlength="6" maxlength="6" [(ngModel)]="otp"
              (keyup)="$event.target.value = $event.target.value.substr(0, 6)" />
            <span class="input__label">Enter OTP</span>
          </label>
        </div>
        <button class="my-button-3 d-flex m-auto" (click)="handleVerify()"><i class="fa-solid fa-save"></i>
          Verify</button>
      </ng-container>
      } @else if(tab === 3) {
      <div class="content__title">Verify</div>
      <div class="content__box verify-content-shepherd">
        <div (click)="!userInfo?.isEmailVerify ? handleOTPVerification(VerifyEmailOtp) : ''" class="btn-verified"
          [class.green]="userInfo?.isEmailVerify">
          <i class="fa fa-envelope icon"></i>
          <div>
            <div class="name">Email</div>
            <div class="meta">{{ userInfo?.isEmailVerify ? "" : "Not" }} Verified</div>
          </div>
          <i class="fa fa-check-circle" [ngStyle]="{
              color: userInfo?.isEmailVerify ? 'green' : 'red'
            }"></i>
        </div>

        <div class="btn-verified" [class.green]="userInfo?.isVerified"
          (click)="userInfo?.isVerified ? '' : (showVerificationTelegram = true)">
          <i class="fa-brands fa-whatsapp icon"></i>
          <div>
            <div class="name">WhatsApp</div>
            <div class="meta">{{ userInfo?.isVerified ? "" : "Not" }} Verified</div>
          </div>
          <i class="fa fa-check-circle" [ngStyle]="{
              color: userInfo?.isVerified ? 'green' : 'red'
            }"></i>
        </div>

        <div class="verification" *ngIf="showVerificationTelegram" [ngClass]="{ active: showVerificationTelegram }">
          <span (click)="showVerificationTelegram = false; isReset = false">
            <i class="fa-solid fa-times" style="color: black !important"></i>
          </span>
          <div>
            <div style="display: flex; justify-content: center; align-items: center">
              <mat-label>Enter OTP</mat-label>
              <mat-form-field style="width: 100%; display: flex; align-items: center; gap: 10px">
                <input matInput formControlName="otp" maxlength="6" style="text-align: center" class="form-control"
                  (change)="onChangeOtp($event)" required />
                <button mat-raised-button color="primary" (click)="sendOtp()" [disabled]="isLoading"
                  style="margin-bottom: 10px" class="btn btn-purple">OTP</button>
              </mat-form-field>
            </div>

            <mat-form-field style="width: 100%; display: flex; flex-direction: column">
              <mat-label class="mb-2 mt-2">Enter 4 Digit Passcode</mat-label>
              <input matInput formControlName="otp" maxlength="4" style="text-align: center" class="form-control mb-2"
                (change)="onChangePasscode($event)" required />
            </mat-form-field>
            <div style="color: red">{{ otpError }}</div>
            <button (click)="verifyOtp()" [disabled]="isLoading" class="btn btn-purple mt-2">Verify</button>
          </div>
        </div>
      </div>

      <div class="content__box verify-content-shepherd">
        <div (click)="userCard ? removecard(VerifyCardOtp) : ''" class="btn-verified" [class.green]="userCard">
          <i class="fa fa-credit-card icon"></i>
          <div>
            <div class="name">Card</div>
            <div class="meta">{{ userCard ? "" : "Not" }} Verified</div>
          </div>
          <i class="fa fa-check-circle" [ngStyle]="{
              color: userCard ? 'green' : 'red'
            }"></i>
        </div>
      </div>

      } @else if(tab === 4){
      <!-- <h1>Refer</h1> -->

      <div style="width: 100%; max-width: 90vw">
        <app-my-carousel-swiper [navigation]="false" [centerSlider]="true" class="my-carousel-width-auto"
          [slide]="referCategories" [config]="carouselOptions"
          *ngIf="referCategories && referCategories.length > 0 && isBrowser">
          <div class="swiper-slide">
            <div [class.active]="!this.selectedBizCategory.id" class="tab" (click)="selectBizCategory(tab)">
              <div>
                <i class="fa-solid fa-star"></i>
                <div class="text">All</div>
              </div>
            </div>
          </div>

          <div class="swiper-slide" *ngFor="let tab of referCategories">
            <a (click)="selectBizCategory(tab)" [class.active]="tab.id == this.selectedBizCategory.id" class="tab">
              <div>
                <i class="fa-solid fa-{{ categoryIconMap[tab.name?.toUpperCase()] }}"></i>
                <div class="text">{{ tab.name }}</div>
              </div>
            </a>
          </div>
        </app-my-carousel-swiper>
        <div
          style="width: 100%; word-wrap: break-word; font-weight: bold; font-size: 1.2rem; color: rgba(128, 0, 128, 0.774); text-overflow: ellipsis"
          class="mb-4 mr-3 ml-3">
          <span>We find only the best businesses with top ratings and affordable prices from Carousell and Google for
            recommendation.</span>
        </div>

        <div class="w-100">
          <div class="cards">
            <!-- <div class="shadow rounded  d-flex flex-column justify-content-center align-items-center "
                    style="position: relative; background-color: transparent;" 
                    *ngFor="let bizCard of bizCards" (click)="showBizPopup(bizCard)" 
                    
                > -->
            <!---------------------------------------------------------------------------------------->
            <div *ngFor="let bizCard of bizCards" class="d-flex flex-column align-items-center justify-content-start"
              style="width: fit-content; height: fit-content">
              <app-biz-name-card [bizCard]="bizCard" (click)="showBizPopup(bizCard)"
                style="min-height: 90%"></app-biz-name-card>
              <div class="mt-1" style="font-size: 1rem; text-decoration: underline; color: purple; font-weight: bold">
                {{ bizCard.shop_name }}
              </div>
            </div>

            <!----------------------------------------------------------------------------------------->
            <!-- <img 
                  
                    style="width: auto; aspect-ratio: 1.4/1; border-radius: 5px;"
                   
                    [src]="bizCard?.shop_banner ? (imgUrl + bizCard?.shop_banner) : '../../../assets/images/no_card.webp'" 
                    [alt]="bizCard?.shop_name" 
                  /> -->
            <!-- <span style="position: absolute; bottom: .6rem; text-overflow: ellipsis; word-break:keep-all; font-size: .6rem; max-width: 100%; height: .7rem; color: rgb(71, 3, 71); font-weight: bold;" class="d-flex flex-column justify-content-center" >
                    <span>{{ bizCard?.shop_name}}</span>
                  </span> -->
            <!-- </div>  -->
          </div>
        </div>
      </div>

      }@else if(tab === 5){
      <div class="content__title">Preferences <button class="my-button-3 mt-4" (click)="startTutorials()">Start
          Tutorials</button></div>
      <div class="content__box">
        <label class="toggle" for="buyerContact">
          <div class="setting-preview">
            <p class="text-center">Preview</p>
            <img loading="lazy" src="../../../../../../assets/images/settings/allowBuyerWhatsApp.png" alt="" />
          </div>
          <input type="checkbox" name="buyerContact" [(ngModel)]="buyerContact" class="toggle__input"
            (change)="allowWhatsappChange()" id="buyerContact" />
          <span class="toggle-track">
            <span class="toggle-indicator">
              <span class="checkMark">
                <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                  <path
                    d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
                  </path>
                </svg>
              </span>
            </span>
          </span>
          Allow Buyer to Contact via Whatsapp
        </label>
        <!---------->
        <label class="toggle" for="allowTelegramContact">
          <div class="setting-preview">
            <p class="text-center">Preview</p>
            <img loading="lazy" src="../../../../../../assets/images/settings/allowChatTelegram.png" alt="" />
          </div>
          <input type="checkbox" (change)="allowTelegramContactChange()" name="allowTelegramContact"
            [(ngModel)]="allowTelegramContact" class="toggle__input" id="allowTelegramContact" />
          <span class="toggle-track">
            <span class="toggle-indicator">
              <span class="checkMark">
                <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                  <path
                    d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
                  </path>
                </svg>
              </span>
            </span>
          </span>
          Allow Buyer to Contact via Telegram
        </label>
        <label class="toggle" for="showCardOnProducts">
          <div class="setting-preview">
            <p class="text-center">Preview</p>
            <img loading="lazy" src="../../../../../../assets/images/settings/showCard.png" alt="" />
          </div>
          <input type="checkbox" name="showCardOnProducts" [(ngModel)]="showCardOnProducts" class="toggle__input"
            id="showCardOnProducts" />
          <span class="toggle-track">
            <span class="toggle-indicator">
              <span class="checkMark">
                <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                  <path
                    d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
                  </path>
                </svg>
              </span>
            </span>
          </span>
          Show Card on my products
        </label>
        <!--showCardOnProducts-->
        <div class="d-flex mb-3 main-toggle" style="position: relative">
          <div class="setting-preview">
            <p class="text-center">Preview</p>
            <img loading="lazy" src="../../../../../../assets/images/settings/allowChatAI.png" alt="" />
          </div>
          <label class="toggle" for="allowBotChat">
            <input type="checkbox" name="allowBotChat" [(ngModel)]="allowBotChat" class="toggle__input"
              id="allowBotChat" />
            <span class="toggle-track">
              <span class="toggle-indicator">
                <span class="checkMark">
                  <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                    <path
                      d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
                    </path>
                  </svg>
                </span>
              </span>
            </span>
            Allow AI To Talk On My Behalf
          </label>
          <span *ngIf="allowBotChat" (click)="openAISettingTab(AISettingTabModal)"
            style="font-size: 18px; cursor: pointer" class="ml-2 my-auto"><i class="fa-solid fa-gear"></i></span>
        </div>

        <label class="toggle" for="addMainAIInMyChat">
          <div class="setting-preview">
            <p class="text-center">Preview</p>
            <img loading="lazy" src="../../../../../../assets/images/settings/addMainAI.png" alt="" />
          </div>
          <input type="checkbox" name="addMainAIInMyChat" [(ngModel)]="addMainAIInMyChat" class="toggle__input"
            id="addMainAIInMyChat" />
          <span class="toggle-track">
            <span class="toggle-indicator">
              <span class="checkMark">
                <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                  <path
                    d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
                  </path>
                </svg>
              </span>
            </span>
          </span>
          Add Main AI Chat in my inbox
        </label>
        <label class="toggle" for="sendMeEmailWhenNewChatStarts">
          <div class="setting-preview">
            <p class="text-center">Preview</p>
            <img loading="lazy" src="../../../../../../assets/images/settings/allowEmailWhenChat.png" alt="" />
          </div>
          <input type="checkbox" name="sendMeEmailWhenNewChatStarts" [(ngModel)]="sendMeEmailWhenNewChatStarts"
            class="toggle__input" id="sendMeEmailWhenNewChatStarts" />
          <span class="toggle-track">
            <span class="toggle-indicator">
              <span class="checkMark">
                <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                  <path
                    d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
                  </path>
                </svg>
              </span>
            </span>
          </span>
          Send me an email when a new chat is started.
        </label>
        <!---------->
        <!-- <label class="toggle" for="tutorials">
          <input type="checkbox" name="tutorial" [checked]="tutorials" (change)="onTutorialsChange($event)" class="toggle__input" id="tutorials" />
          <span class="toggle-track">
            <span class="toggle-indicator">
              <span class="checkMark">
                <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                  <path d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z"></path>
                </svg>
              </span>
            </span>
          </span>
          Active Tutorial
        </label> -->
      </div>

      <div class="content__title">Profile Character</div>

      <div class="content__box w-full">
        <button class="my-button-3" (click)="setProfileToDefault()"><i class="fa-solid fa-user-check"></i> Set Profile
          to Default</button>
        <button class="my-button-3 ml-3" (click)="setProfileToAvatar()"><i class="fa-solid fa-user-check"></i> Set
          Profile to Avatar</button>
      </div>

      <div class="content__title">Dashboard</div>
      <div class="content__box">
        <label class="toggle">Show Category Tabs</label>
        <ng-container *ngFor="let i of categoryTabs">
          <div class="sub-cate__item" [ngClass]="{ active: i.checked }">
            <input [id]="i?.name" style="opacity: 1; width: 20px" type="checkbox" (change)="handleHideCategoryTab(i)"
              [(ngModel)]="i.checked" />
            <label [for]="i?.name">{{ i?.name | titlecase }}</label>
          </div>
        </ng-container>
      </div>

      <div class="content__title">Notifications</div>
      <div class="content__box">
        <label class="toggle" for="turnOffWhatsapp">
          <div class="setting-preview">
            <p class="text-center">Preview</p>
            <img loading="lazy" src="../../../../../../assets/images/settings/allowBookNow.png" alt="" />
          </div>
          <input type="checkbox" name="turnOffWhatsapp" [(ngModel)]="turnOffWhatsapp" class="toggle__input"
            id="turnOffWhatsapp" />
          <span class="toggle-track">
            <span class="toggle-indicator">
              <span class="checkMark">
                <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                  <path
                    d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
                  </path>
                </svg>
              </span>
            </span>
          </span>
          Whatsapp Booking Notification
        </label>
        <label class="toggle" for="showMeNotifications">
          <input type="checkbox" name="showMeNotifications" [(ngModel)]="showMeNotifications" class="toggle__input"
            id="showMeNotifications" />
          <span class="toggle-track">
            <span class="toggle-indicator">
              <span class="checkMark">
                <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                  <path
                    d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
                  </path>
                </svg>
              </span>
            </span>
          </span>
          Send me web notifications
        </label>
      </div>

      <div class="content__title">Shop</div>
      <div class="content__box">
        <label class="toggle" for="template">
          <input type="checkbox" name="template" [(ngModel)]="enableTemplate" class="toggle__input" id="template" />
          <span class="toggle-track">
            <span class="toggle-indicator">
              <span class="checkMark">
                <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                  <path
                    d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
                  </path>
                </svg>
              </span>
            </span>
          </span>
          Enable Template Option (For Product Creation)
        </label>
        <!-- <label class="toggle" for="showMeNotifications">
          <input type="checkbox" name="showMeNotifications" [(ngModel)]="showMeNotifications" class="toggle__input" id="showMeNotifications" />
          <span class="toggle-track">
            <span class="toggle-indicator">
              <span class="checkMark">
                <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
                  <path d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z"></path>
                </svg>
              </span>
            </span>
          </span>
          Send me notifications on Apps
        </label> -->
      </div>
      <button class="my-button-3 d-flex m-auto" (click)="saveProfileInfo()"><i class="fa-solid fa-save"></i>
        Save</button>
      } @else if(tab === 6) {
      <div class="content__title">User Tags</div>
      <div class="content__box d-flex">
        <div class="tag m-1" *ngFor="let i of commonService.userTagList">{{ i }}<i class="fa fa-times ml-2"
            aria-hidden="true" (click)="ignoreTag(i)"></i></div>
      </div>
      } @else if(tab === 7) { @if((userInfo?.level ?? 1) < 5){ <div class="not-allowed">You have to be level 5 and above
        to subscribe or purchase tokens
    </div>
    }
    <div class="header">
      <div class="text-left">
        <h2>PURCHASE DIAMONDS</h2>
        <div class="desc">Diamonds are for in-store items and upgrades. There is no refund provided for purchases,
          please contact Help Center if you need help.</div>
      </div>
    </div>
    <div class="my-grid">
      <div class="my-card">
        <div class="bg-icon">
          <svg viewBox="0 0 585 474" fill="none">
            <path
              d="M267.465 0H109.258C107.461 0 105.845 1.15 105.119 2.953C104.38 4.751 104.677 6.839 105.863 8.315L184.406 105.359C185.277 106.424 186.488 107.03 187.795 107.036C189.102 107.042 190.312 106.449 191.19 105.389L270.841 8.345C272.039 6.874 272.354 4.774 271.616 2.965C270.89 1.162 269.256 0 267.465 0Z" />
            <path
              d="M179.988 127.698H18.1804C16.3894 127.698 14.7794 128.836 14.0414 130.621C13.3024 132.407 13.5694 134.483 14.7374 135.971L259.076 445.758C260.474 447.537 262.817 448.01 264.675 446.878C266.563 445.746 267.477 443.338 266.878 441.08L184.364 131.293C183.777 129.163 182.004 127.698 179.988 127.698Z" />
            <path
              d="M475.353 0.00488281H310.906C309.078 0.00488281 307.444 1.18588 306.718 3.03088C306.017 4.87688 306.343 6.99488 307.602 8.44788L391.944 105.71C392.828 106.708 394.05 107.277 395.309 107.259C396.604 107.235 397.796 106.624 398.649 105.589C414.542 85.9739 457.777 32.7949 478.675 8.42886C479.904 6.97086 480.249 4.84586 479.541 3.01886C478.803 1.18586 477.168 0.00488281 475.353 0.00488281Z" />
            <path
              d="M571.182 127.747H402.813C400.756 127.747 398.976 129.266 398.425 131.433L320.88 443.241C320.317 445.498 321.243 447.87 323.119 448.972C325.007 450.079 327.32 449.601 328.717 447.834L574.619 136.02C575.793 134.549 576.059 132.455 575.309 130.676C574.583 128.89 572.979 127.747 571.182 127.747Z" />
            <path
              d="M289.033 7.80591C287.774 7.81791 286.564 8.41789 285.717 9.45789L205.588 107.072C204.389 108.536 204.075 110.649 204.801 112.446C205.54 114.249 207.162 115.411 208.971 115.411H373.75C375.578 115.411 377.212 114.225 377.938 112.385C378.646 110.533 378.301 108.421 377.042 106.968L292.398 9.35392C291.521 8.34592 290.304 7.78191 289.033 7.80591Z"
              class="grey" />
            <path
              d="M495.059 7.80591C493.782 7.81791 492.589 8.41789 491.718 9.45789L411.601 107.072C410.384 108.536 410.1 110.649 410.814 112.446C411.553 114.249 413.175 115.411 414.978 115.411H579.763C581.585 115.411 583.225 114.225 583.927 112.385C584.671 110.533 584.308 108.421 583.067 106.968L498.411 9.35392C497.528 8.34592 496.317 7.78191 495.059 7.80591Z"
              class="grey" />
            <path
              d="M84.6316 7.80591C83.3606 7.81791 82.1626 8.41789 81.3146 9.45789L1.17357 107.072C-0.0364274 108.536 -0.339421 110.649 0.398579 112.446C1.12458 114.249 2.75956 115.411 4.55056 115.411H169.318C171.164 115.411 172.798 114.225 173.525 112.385C174.245 110.533 173.882 108.421 172.623 106.968L87.9846 9.35392C87.1196 8.34592 85.9026 7.78191 84.6316 7.80591Z"
              class="grey" />
            <path
              d="M204.996 128.364C203.561 128.364 202.206 129.114 201.34 130.367C200.475 131.62 200.208 133.266 200.614 134.773L289.882 469.906C290.451 472.06 292.279 473.525 294.288 473.507C296.334 473.495 298.113 471.97 298.645 469.828L381.982 134.689C382.357 133.188 382.061 131.572 381.232 130.331C380.361 129.097 379.011 128.365 377.595 128.365H204.996V128.364Z" />
          </svg>
        </div>
        <div class="price"><span>$</span> 10</div>
        <div class="amount">100<span>Diamonds</span></div>
        <button class="my-button-3" (click)="subscribeto(1)">Buy Now</button>
      </div>
      <div class="my-card lg">
        <div class="bg-icon">
          <svg viewBox="0 0 585 474" fill="none">
            <path
              d="M267.465 0H109.258C107.461 0 105.845 1.15 105.119 2.953C104.38 4.751 104.677 6.839 105.863 8.315L184.406 105.359C185.277 106.424 186.488 107.03 187.795 107.036C189.102 107.042 190.312 106.449 191.19 105.389L270.841 8.345C272.039 6.874 272.354 4.774 271.616 2.965C270.89 1.162 269.256 0 267.465 0Z" />
            <path
              d="M179.988 127.698H18.1804C16.3894 127.698 14.7794 128.836 14.0414 130.621C13.3024 132.407 13.5694 134.483 14.7374 135.971L259.076 445.758C260.474 447.537 262.817 448.01 264.675 446.878C266.563 445.746 267.477 443.338 266.878 441.08L184.364 131.293C183.777 129.163 182.004 127.698 179.988 127.698Z" />
            <path
              d="M475.353 0.00488281H310.906C309.078 0.00488281 307.444 1.18588 306.718 3.03088C306.017 4.87688 306.343 6.99488 307.602 8.44788L391.944 105.71C392.828 106.708 394.05 107.277 395.309 107.259C396.604 107.235 397.796 106.624 398.649 105.589C414.542 85.9739 457.777 32.7949 478.675 8.42886C479.904 6.97086 480.249 4.84586 479.541 3.01886C478.803 1.18586 477.168 0.00488281 475.353 0.00488281Z" />
            <path
              d="M571.182 127.747H402.813C400.756 127.747 398.976 129.266 398.425 131.433L320.88 443.241C320.317 445.498 321.243 447.87 323.119 448.972C325.007 450.079 327.32 449.601 328.717 447.834L574.619 136.02C575.793 134.549 576.059 132.455 575.309 130.676C574.583 128.89 572.979 127.747 571.182 127.747Z" />
            <path
              d="M289.033 7.80591C287.774 7.81791 286.564 8.41789 285.717 9.45789L205.588 107.072C204.389 108.536 204.075 110.649 204.801 112.446C205.54 114.249 207.162 115.411 208.971 115.411H373.75C375.578 115.411 377.212 114.225 377.938 112.385C378.646 110.533 378.301 108.421 377.042 106.968L292.398 9.35392C291.521 8.34592 290.304 7.78191 289.033 7.80591Z"
              class="grey" />
            <path
              d="M495.059 7.80591C493.782 7.81791 492.589 8.41789 491.718 9.45789L411.601 107.072C410.384 108.536 410.1 110.649 410.814 112.446C411.553 114.249 413.175 115.411 414.978 115.411H579.763C581.585 115.411 583.225 114.225 583.927 112.385C584.671 110.533 584.308 108.421 583.067 106.968L498.411 9.35392C497.528 8.34592 496.317 7.78191 495.059 7.80591Z"
              class="grey" />
            <path
              d="M84.6316 7.80591C83.3606 7.81791 82.1626 8.41789 81.3146 9.45789L1.17357 107.072C-0.0364274 108.536 -0.339421 110.649 0.398579 112.446C1.12458 114.249 2.75956 115.411 4.55056 115.411H169.318C171.164 115.411 172.798 114.225 173.525 112.385C174.245 110.533 173.882 108.421 172.623 106.968L87.9846 9.35392C87.1196 8.34592 85.9026 7.78191 84.6316 7.80591Z"
              class="grey" />
            <path
              d="M204.996 128.364C203.561 128.364 202.206 129.114 201.34 130.367C200.475 131.62 200.208 133.266 200.614 134.773L289.882 469.906C290.451 472.06 292.279 473.525 294.288 473.507C296.334 473.495 298.113 471.97 298.645 469.828L381.982 134.689C382.357 133.188 382.061 131.572 381.232 130.331C380.361 129.097 379.011 128.365 377.595 128.365H204.996V128.364Z" />
          </svg>
        </div>
        <div class="price"><span>$</span> 50</div>
        <div class="amount">600<span>Diamonds</span></div>
        <div class="save_info">SAVE 20%</div>
        <button class="my-button-3" (click)="subscribeto(2)">Buy Now</button>
      </div>
      <div class="my-card">
        <div class="bg-icon">
          <svg viewBox="0 0 585 474" fill="none">
            <path
              d="M267.465 0H109.258C107.461 0 105.845 1.15 105.119 2.953C104.38 4.751 104.677 6.839 105.863 8.315L184.406 105.359C185.277 106.424 186.488 107.03 187.795 107.036C189.102 107.042 190.312 106.449 191.19 105.389L270.841 8.345C272.039 6.874 272.354 4.774 271.616 2.965C270.89 1.162 269.256 0 267.465 0Z" />
            <path
              d="M179.988 127.698H18.1804C16.3894 127.698 14.7794 128.836 14.0414 130.621C13.3024 132.407 13.5694 134.483 14.7374 135.971L259.076 445.758C260.474 447.537 262.817 448.01 264.675 446.878C266.563 445.746 267.477 443.338 266.878 441.08L184.364 131.293C183.777 129.163 182.004 127.698 179.988 127.698Z" />
            <path
              d="M475.353 0.00488281H310.906C309.078 0.00488281 307.444 1.18588 306.718 3.03088C306.017 4.87688 306.343 6.99488 307.602 8.44788L391.944 105.71C392.828 106.708 394.05 107.277 395.309 107.259C396.604 107.235 397.796 106.624 398.649 105.589C414.542 85.9739 457.777 32.7949 478.675 8.42886C479.904 6.97086 480.249 4.84586 479.541 3.01886C478.803 1.18586 477.168 0.00488281 475.353 0.00488281Z" />
            <path
              d="M571.182 127.747H402.813C400.756 127.747 398.976 129.266 398.425 131.433L320.88 443.241C320.317 445.498 321.243 447.87 323.119 448.972C325.007 450.079 327.32 449.601 328.717 447.834L574.619 136.02C575.793 134.549 576.059 132.455 575.309 130.676C574.583 128.89 572.979 127.747 571.182 127.747Z" />
            <path
              d="M289.033 7.80591C287.774 7.81791 286.564 8.41789 285.717 9.45789L205.588 107.072C204.389 108.536 204.075 110.649 204.801 112.446C205.54 114.249 207.162 115.411 208.971 115.411H373.75C375.578 115.411 377.212 114.225 377.938 112.385C378.646 110.533 378.301 108.421 377.042 106.968L292.398 9.35392C291.521 8.34592 290.304 7.78191 289.033 7.80591Z"
              class="grey" />
            <path
              d="M495.059 7.80591C493.782 7.81791 492.589 8.41789 491.718 9.45789L411.601 107.072C410.384 108.536 410.1 110.649 410.814 112.446C411.553 114.249 413.175 115.411 414.978 115.411H579.763C581.585 115.411 583.225 114.225 583.927 112.385C584.671 110.533 584.308 108.421 583.067 106.968L498.411 9.35392C497.528 8.34592 496.317 7.78191 495.059 7.80591Z"
              class="grey" />
            <path
              d="M84.6316 7.80591C83.3606 7.81791 82.1626 8.41789 81.3146 9.45789L1.17357 107.072C-0.0364274 108.536 -0.339421 110.649 0.398579 112.446C1.12458 114.249 2.75956 115.411 4.55056 115.411H169.318C171.164 115.411 172.798 114.225 173.525 112.385C174.245 110.533 173.882 108.421 172.623 106.968L87.9846 9.35392C87.1196 8.34592 85.9026 7.78191 84.6316 7.80591Z"
              class="grey" />
            <path
              d="M204.996 128.364C203.561 128.364 202.206 129.114 201.34 130.367C200.475 131.62 200.208 133.266 200.614 134.773L289.882 469.906C290.451 472.06 292.279 473.525 294.288 473.507C296.334 473.495 298.113 471.97 298.645 469.828L381.982 134.689C382.357 133.188 382.061 131.572 381.232 130.331C380.361 129.097 379.011 128.365 377.595 128.365H204.996V128.364Z" />
          </svg>
        </div>
        <div class="price"><span>$</span> 100</div>
        <div class="amount">1300<span>Diamonds</span></div>
        <div class="save_info">SAVE 30%</div>
        <button class="my-button-3" (click)="subscribeto(3)">Buy Now</button>
      </div>
    </div>
    <br />
    <br />
    <div class="header">
      <div class="text-left">
        <h2>SUBSCRIPTIONS</h2>
        <div class="desc">Select a subscription plan that fits your needs. You can cancel anytime.</div>
      </div>

      <button class="my-button-3" (click)="managesub()">Manage Subscriptions</button>
    </div>

    <div class="my-grid">
      <div class="my-card space-b">
        <div>
          <svg viewBox="0 0 1269 801" fill="none">
            <path
              d="M480.924 549.558C491.226 559.189 491.77 575.347 482.14 585.649C472.509 595.951 456.35 596.495 446.049 586.864C435.747 577.234 435.202 561.075 444.833 550.773C454.464 540.471 470.622 539.927 480.924 549.558Z"
              fill="#518FDA" stroke="white" stroke-width="3" />
            <path
              d="M512.477 620.266V620.266V628.631V679.525C512.477 684.171 508.712 687.936 504.067 687.936C499.422 687.936 495.657 684.171 495.657 679.525V630.448C495.657 628.616 494.172 627.131 492.34 627.131C490.507 627.131 489.022 628.616 489.022 630.448V695.782V704.02V774.337C489.022 780.375 484.128 785.27 478.089 785.27C472.051 785.27 467.156 780.375 467.156 774.337V706.187C467.156 704.162 465.514 702.52 463.489 702.52C461.464 702.52 459.822 704.162 459.822 706.187V774.337C459.822 780.375 454.927 785.27 448.888 785.27C442.85 785.27 437.955 780.375 437.955 774.337V704.02V695.782V630.448C437.955 628.616 436.47 627.131 434.638 627.131C432.806 627.131 431.321 628.616 431.321 630.448V679.525C431.321 684.171 427.556 687.936 422.91 687.936C418.265 687.936 414.5 684.171 414.5 679.525V628.631V620.266C414.5 610.148 422.703 601.945 432.821 601.945H436.455H490.524H494.158C504.277 601.945 512.479 610.148 512.477 620.266Z"
              fill="#518FDA" stroke="white" stroke-width="3" />
            <line x1="1269" y1="796" x2="4.37114e-07" y2="796" stroke="#3E4D57" stroke-width="10" />
            <path d="M1017 734C1017 731.239 1019.24 729 1022 729H1068C1070.76 729 1073 731.239 1073 734V798H1017V734Z"
              fill="#3E4D57" />
            <path d="M1027 741C1027 738.239 1029.24 736 1032 736H1058C1060.76 736 1063 738.239 1063 741V791H1027V741Z"
              fill="#F1C858" />
            <path
              d="M1117.99 627.643C1118.44 644.746 1104.55 659.898 1097.55 665.337C1081.19 677.939 1052.87 680.339 1040.76 679.964C1009.53 679.964 999.872 673.213 986.243 665.337C974.886 655.772 971 641.707 971 631.018C971 614.703 979.997 602.326 993.626 594.449C1008.66 585.759 1007.82 574.832 1006.69 560.767C1005.34 544.16 1024.86 523 1053.82 523C1080.62 523 1088.84 542.128 1090.73 551.692C1092.43 578.134 1094.48 579.324 1103.22 591.074C1111.17 601.763 1117.42 606.264 1117.99 627.643Z"
              fill="#3E4D57" />
            <path
              d="M1110 627C1110.4 642.2 1098.17 655.667 1092 660.5C1077.6 671.7 1052.67 673.833 1042 673.5C1014.5 673.5 1006 667.5 993.999 660.5C984 652 980.578 639.5 980.578 630C980.578 615.5 988.5 604.5 1000.5 597.5C1013.74 589.776 1013 580.065 1012 567.565C1010.82 552.806 1028 534 1053.5 534C1077.1 534 1084.33 551 1086 559.5C1087.5 583 1089.3 584.057 1097 594.5C1104 604 1109.5 608 1110 627Z"
              fill="#0EB39B" />
            <circle cx="1089" cy="435" r="12" fill="#3E4D57" />
            <circle cx="1098" cy="479" r="12" fill="#3E4D57" />
            <circle cx="1098" cy="526" r="12" fill="#3E4D57" />
            <circle cx="1065" cy="395" r="12" fill="#3E4D57" />
            <circle cx="1033" cy="359" r="12" fill="#3E4D57" />
            <circle cx="993" cy="335" r="12" fill="#3E4D57" />
            <circle cx="949" cy="323" r="12" fill="#3E4D57" />
            <circle cx="782.999" cy="596.131" r="12" transform="rotate(159.275 782.999 596.131)" fill="#3E4D57" />
            <circle cx="759.01" cy="558.163" r="12" transform="rotate(159.275 759.01 558.163)" fill="#3E4D57" />
            <circle cx="742.378" cy="514.204" r="12" transform="rotate(159.275 742.378 514.204)" fill="#3E4D57" />
            <circle cx="819.602" cy="625.049" r="12" transform="rotate(159.275 819.602 625.049)" fill="#3E4D57" />
            <circle cx="862.271" cy="647.395" r="12" transform="rotate(159.275 862.271 647.395)" fill="#3E4D57" />
            <circle cx="908.176" cy="655.686" r="12" transform="rotate(159.275 908.176 655.686)" fill="#3E4D57" />
            <circle cx="953.575" cy="651.338" r="12" transform="rotate(159.275 953.575 651.338)" fill="#3E4D57" />
            <circle cx="815.311" cy="352.092" r="12" transform="rotate(-104.483 815.311 352.092)" fill="#3E4D57" />
            <circle cx="855.663" cy="332.374" r="12" transform="rotate(-104.483 855.663 332.374)" fill="#3E4D57" />
            <circle cx="901.169" cy="320.62" r="12" transform="rotate(-104.483 901.169 320.62)" fill="#3E4D57" />
            <circle cx="782.585" cy="385.333" r="12" transform="rotate(-104.483 782.585 385.333)" fill="#3E4D57" />
            <circle cx="755.732" cy="425.319" r="12" transform="rotate(-104.483 755.732 425.319)" fill="#3E4D57" />
            <circle cx="742.498" cy="470.05" r="12" transform="rotate(-104.483 742.498 470.05)" fill="#3E4D57" />
            <path d="M35 0H284V24H159.5H35V0Z" fill="black" fill-opacity="0.22" />
            <rect x="101" y="28" width="157" height="24" fill="black" fill-opacity="0.26" />
            <rect x="77" y="56" width="249" height="24" fill="black" fill-opacity="0.25" />
            <path
              d="M583.908 631.74C595.986 631.74 605.778 621.948 605.778 609.87C605.778 597.792 595.986 588 583.908 588C571.829 588 562.038 597.792 562.038 609.87C562.038 621.948 571.829 631.74 583.908 631.74Z"
              fill="white" stroke="white" stroke-width="2.5" stroke-miterlimit="10" />
            <path
              d="M604.871 672.572C604.905 672.552 604.892 672.56 604.926 672.54C608.257 679.307 614.685 692.366 618.702 700.527C620.656 704.496 625.456 706.126 629.425 704.172L629.431 704.169C633.403 702.214 635.039 697.408 633.083 693.435L614.9 656.496L608.723 643.828C606.367 638.996 601.462 635.931 596.086 635.931H583.47H583.439H570.823C565.447 635.931 560.542 638.996 558.186 643.828L552.009 656.496L533.826 693.435C531.871 697.408 533.506 702.213 537.478 704.169L537.484 704.172C541.453 706.126 546.253 704.496 548.207 700.527C552.224 692.366 558.652 679.307 561.983 672.54C562.017 672.56 562.004 672.552 562.038 672.572L545.631 724.692C543.706 729.084 546.923 734.007 551.719 734.007H560.907C561.531 734.007 562.038 734.513 562.038 735.138V776.603C562.038 782.158 566.541 786.661 572.096 786.661C577.651 786.661 582.154 782.158 582.154 776.603V734.849C582.154 734.384 582.531 734.008 582.995 734.008H583.914C584.379 734.008 584.755 734.385 584.755 734.849V776.603C584.755 782.158 589.258 786.661 594.813 786.661C600.368 786.661 604.871 782.158 604.871 776.603V735.138C604.871 734.514 605.377 734.007 606.002 734.007H615.19C619.985 734.007 623.203 729.084 621.278 724.692L604.871 672.572Z"
              fill="white" stroke="white" stroke-width="2.5" stroke-miterlimit="10" />
            <path
              d="M605.278 609.87C605.278 621.672 595.71 631.24 583.908 631.24C572.106 631.24 562.538 621.672 562.538 609.87C562.538 598.068 572.106 588.5 583.908 588.5C595.71 588.5 605.278 598.068 605.278 609.87Z"
              fill="#E04F6F" stroke="white" />
            <path
              d="M604.617 672.141L604.274 672.343L604.394 672.722L620.801 724.842L620.809 724.868L620.82 724.893C622.6 728.954 619.624 733.507 615.19 733.507H606.002C605.1 733.507 604.371 734.238 604.371 735.138V776.603C604.371 781.882 600.092 786.161 594.813 786.161C589.534 786.161 585.255 781.882 585.255 776.603V734.849C585.255 734.109 584.655 733.508 583.914 733.508H582.995C582.255 733.508 581.654 734.108 581.654 734.849V776.603C581.654 781.882 577.375 786.161 572.096 786.161C566.817 786.161 562.538 781.882 562.538 776.603V735.138C562.538 734.237 561.807 733.507 560.907 733.507H551.719C547.283 733.507 544.309 728.955 546.089 724.893L546.1 724.868L546.108 724.842L562.515 672.722L562.634 672.343L562.291 672.141C562.272 672.13 562.265 672.126 562.258 672.122L562.236 672.109L561.772 671.836L561.534 672.319L547.758 700.306C545.926 704.027 541.426 705.556 537.705 703.724L537.701 703.722L537.699 703.721C533.974 701.887 532.441 697.381 534.274 693.656L552.457 656.717L552.458 656.715L558.635 644.047L558.186 643.828L558.635 644.047C560.907 639.387 565.638 636.431 570.823 636.431H583.439H583.47H596.086C601.271 636.431 606.001 639.387 608.273 644.047L608.723 643.828L608.273 644.047L614.45 656.715L614.451 656.717L632.634 693.656C634.468 697.381 632.934 701.887 629.21 703.721L629.207 703.722L629.204 703.724C629.204 703.724 629.203 703.724 629.203 703.724C625.482 705.555 620.982 704.027 619.15 700.306L605.374 672.319L605.136 671.836L604.672 672.109L604.65 672.122C604.648 672.124 604.645 672.125 604.641 672.127C604.636 672.13 604.629 672.134 604.617 672.141Z"
              fill="#E04F6F" stroke="white" />
            <rect x="1039" y="677" width="12" height="52" fill="#3E4D57" />
          </svg>
          <div class="my-card__title">FREE</div>
        </div>
        <ul>
          <li>
            <div class="item">
              <div class="icon"><i class="fa-solid fa-check"></i></div>
              3 Products in each category
            </div>
          </li>
          <li>
            <div class="item">
              <div class="icon"><i class="fa-solid fa-check"></i></div>
              Max 3 enquiries per product per day
            </div>
          </li>
        </ul>
        <div class="my-card__footer">
          <div class="amount">Free <span>/ 1 Month Trial</span></div>
          <div class="name-amount">(super seller)</div>
          <button class="my-button-3 mt-4 secondary" (click)="subscribeto(4)">Buy now</button>
        </div>
      </div>
      <div class="my-card lg space-b">
        <div>
          <img loading="lazy" src="../../../../../../assets/images/icon-price.png" alt="" />
          <div class="my-card__title">ADVANCED SELLER</div>
        </div>
        <ul>
          <li>
            <div class="item">
              <div class="icon"><i class="fa-solid fa-check"></i></div>
              6 Products in each category
            </div>
          </li>
          <li>
            <div class="item">
              <div class="icon"><i class="fa-solid fa-check"></i></div>
              Max 6 enquiries per product per day
            </div>
          </li>
        </ul>
        <div class="my-card__footer">
          <div class="amount">$ 59<span>/ Month</span></div>
          <button class="my-button-3 mt-4 secondary" (click)="subscribeto(5)">Buy now</button>
        </div>
      </div>
      <div class="my-card space-b">
        <div>
          <img loading="lazy" src="../../../../../../assets/images/icon-price-2.png" alt="" />
          <div class="my-card__title">SUPER SELLER</div>
        </div>
        <ul>
          <li>
            <div class="item">
              <div class="icon"><i class="fa-solid fa-check"></i></div>
              12 Products in each category
            </div>
          </li>
          <li>
            <div class="item">
              <div class="icon"><i class="fa-solid fa-check"></i></div>
              Max 10 enquiries per product per day
            </div>
          </li>
          <li>
            <div class="item" (click)="showList = !showList">
              <div class="icon"><i class="fa-solid fa-check"></i></div>
              <div>
                Super Seller Role Unlocked
                <i class="fa-chevron-down fa-solid"></i>
              </div>
            </div>
            <div class="sub-list" [class.active]="showList">
              <div class="sub-list__item">- Calendar Feature</div>
              <div class="sub-list__item">- More Products</div>
              <div class="sub-list__item">- Socials</div>
              <div class="sub-list__item">- Attach product</div>
              <div class="sub-list__item">- Discuss</div>
              <div class="sub-list__item">- Rent Deposit Function</div>
            </div>
          </li>
        </ul>
        <div class="my-card__footer">
          <div class="amount">$ 199<span>/ Month</span></div>
          <button class="my-button-3 mt-4 secondary" (click)="subscribeto(6)">Buy now</button>
        </div>
      </div>
    </div>
    } @else if(tab === 8){
    <div class="content__title">Blocked Users</div>
    <div class="content__box">
      <div *ngFor="let block of blocks" class="d-flex justify-content-between"
        style="font-size: 16px; margin-bottom: 5px">
        <span>{{ block["blocked"]["profileCharacterName"] ?? "User" }}({{ block["timeOfBlock"] | date : "dd/MM/yyyy"
          }})</span>
        <button (click)="unblock(block['blockedId'])"
          style="color: deeppink; background-color: transparent; border: 0px; font-size: 12px">Unblock</button>
      </div>
    </div>

    <div class="content__title">Telegram Chat Bot</div>
    <div class="d-flex justify-content-evenly">
      <div (click)="getTelegramLinks()" class="btn-verified mb-5 mt-2 tg-btn" [class.green]="userInfo?.telegramId">
        <i class="fa-brands fa-telegram icon"></i>
        <div>
          <div class="name">Telegram Account</div>
          <div class="meta">{{ userInfo?.telegramId ? "" : "Not" }} Verified</div>
        </div>
        <i class="fa fa-check-circle" [ngStyle]="{
              color: userInfo?.telegramId ? 'green' : 'red'
            }"></i>
      </div>

      <div (click)="openTelegramPhoneConfirmation()" class="btn-verified mb-5 mt-2 tg-btn"
        [class.green]="userInfo?.isTelegramVerified">
        <i class="fa-brands fa-telegram icon"></i>
        <div>
          <div class="name">Telegram Phone Number</div>
          <div class="meta">{{ userInfo?.isTelegramVerified ? "" : "Not" }} Verified</div>
        </div>
        <i class="fa fa-check-circle" [ngStyle]="{
              color: userInfo?.isTelegramVerified ? 'green' : 'red'
            }"></i>
      </div>
    </div>

    <div class="white_box shadow p-3 d-flex flex-column justify-content-start">
      @if(isBotInfoLoading){
      <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center vh-100">
        <div class="spinner-border text-primary" role="status">
          <span>Loading...</span>
        </div>
      </div>
      }@else if(isBotRegisterationError || !registeredBotToken || isBotBeingEdited){

      <div class="d-flex flex-column justify-content-center mb-6">
        <span>1. Go to <a style="font-weight: bold; color: blue; text-decoration: underline"
            href="https://t.me/BotFather" target="_blank">Bot Father</a></span>
        <span>2. Press the start button on the bot and send <span
            style="background-color: lightblue; font-weight: bold; color: darkblue; font-style: italic">/newbot</span>
          as text message(as you would send anyone) </span>
        <span>3. Give the Bot the name you want and also the username <span
            style="color: purple; font-weight: bold">*Remember you cannot change username after create your bot</span>
        </span>
        <span>4. Copy the token from the bot and send it here</span>
        <span style="font-weight: bold; color: purple">5. After adding token to settings open up your telegram by
          clicking "Open telegram bot from here" to connect bot</span>
      </div>
      <input type="text" [(ngModel)]="candidateBotToken" class="mt-4 p-2" placeholder="Telegram Bot token"
        style="border-radius: 6px" />
      <button class="btn mb-4" (click)="updateTelegramBotRegisteration()"><i class="fa fa-file"></i> Register</button>
      <button (click)="isBotBeingEdited = false" class="btn btn-danger" *ngIf="isBotBeingEdited"><i class="fa fa-x"></i>
        Cancel</button>

      }@else if(registeredBotToken){
      <div class="d-flex flex-column justify-content-evenly">
        <div>
          <span>Username: </span> <span style="color: purple">{{ registeredBotUsername }}</span>
        </div>
        <div>
          <span>Token: </span> <span style="color: purple">{{ registeredBotToken }}</span>
        </div>
        <button (click)="isBotBeingEdited = true; candidateBotToken = registeredBotToken ?? ''" class="btn"><i
            class="fa fa-pen"></i> Change</button>
      </div>
      <div class="mt-3 d-flex flex-column justify-content-evenly">
        @if(isTelegramUserError){
        <div class="d-flex w-100 justify-content-center"><i class="fa-solid fa-triangle-exclamation"></i> Something is
          wrong with your account please make sure you have not blocked the bot or your account is not locked.</div>
        } @if(telegramUserId){
        <div>
          <span>Telegram ID: </span> <span style="color: purple">{{ telegramUserId }}</span>
        </div>
        <div *ngIf="telegramUserFullName">
          <span>Telegram Name: </span> <span style="color: purple">{{ telegramUserFullName }}</span>
        </div>
        <div *ngIf="telegramUsername">
          <span>Telegram Username: </span> <span style="color: purple">{{ telegramUsername }}</span>
        </div>
        <button class="btn" (click)="openRegistration()"><i class="fa fa-pen"></i> Open telegram bot from
          here</button>

        <div class="d-flex w-100 justify-content-center mt-3 align-items-center center"><i
            class="fa-solid fa-triangle-exclamation mr-4"></i>Always make sure you have not blocked or deleted the bot
          and your account is also functional</div>
        }@else{
        <div class="d-flex flex-column justify-content-center mb-6">
          <span>1. Press the button below</span>
          <span>2. Press Start on the bot</span>
        </div>
        <div class="d-flex flex-column mt-3">
          <span style="font-weight: bold"> <i class="fa-solid fa-triangle-exclamation"></i> *Inorder to chat you have
            to register your telegram account</span>
        </div>
        <button class="btn" (click)="openRegistration()"><i class="fa fa-pen"></i> Open telegram bot from
          here</button>

        }
      </div>
      }@else{
      <span>Something went wrong please retry latter</span>
      }
    </div>

    <!-- <div class="btn-verified mt-4" [class.green]="registeredBotToken">
      <i class="fa-brands fa-telegram icon"></i>
      <div>
        <div class="name">Telegram Chat Bot</div>
        <div class="meta">{{ registeredBotToken ? "" : "Not" }} Verified</div>
      </div>
      <i class="fa fa-check-circle" [ngStyle]="{
            color: registeredBotToken ? 'green' : 'red'
          }"></i>
    </div> -->

    } @else if(tab === 9){ @if((userInfo?.level ?? 1) < 5){ <div class="not-allowed">You have to be level 5 and above
      to subscribe or purchase tokens
  </div>
  }
  <div class="content__title">Exclusive Features for Super Sellers</div>
  <div class="content__box">
    <label *ngFor="let option of superSellerFeatures" class="toggle" for="buyerContact">
      <input type="checkbox" name="buyerContact" [value]="false" [disabled]="true" class="toggle__input"
        id="buyerContact" />
      <span class="toggle-track">
        <span class="toggle-indicator">
          <span class="checkMark">
            <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
              <path
                d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
              </path>
            </svg>
          </span>
        </span>
      </span>
      {{ option }}
    </label>

    <label class="toggle" for="allowBookDriver">
      <input type="checkbox" name="allowBookDriver" [(ngModel)]="allowBookDriver" class="toggle__input"
        id="allowBookDriver" />
      <span class="toggle-track">
        <span class="toggle-indicator">
          <span class="checkMark">
            <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
              <path
                d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
              </path>
            </svg>
          </span>
        </span>
      </span>
      Allow Driver Bookings
    </label>
  </div>
  } @else if(tab === 10) {
  <div class="content__title">SEO</div>
  <div class="content__box">
    <label class="toggle" for="noIndexProduct">
      <input type="checkbox" name="noIndexProduct" [(ngModel)]="noIndexProduct" class="toggle__input"
        id="noIndexProduct" />
      <span class="toggle-track">
        <span class="toggle-indicator">
          <span class="checkMark">
            <svg viewBox="0 0 24 24" id="ghq-svg-check" role="presentation" aria-hidden="true">
              <path
                d="M9.86 18a1 1 0 01-.73-.32l-4.86-5.17a1.001 1.001 0 011.46-1.37l4.12 4.39 8.41-9.2a1 1 0 111.48 1.34l-9.14 10a1 1 0 01-.73.33h-.01z">
              </path>
            </svg>
          </span>
        </span>
      </span>
      Google Search is <span class="ml-1 text-{{ noIndexProduct ? 'success' : 'danger' }}">{{ noIndexProduct ?
        "Enabled" : "Disabled" }}</span>
    </label>
  </div>
  <button class="my-button-3 d-flex m-auto" (click)="saveProfileInfo()"><i class="fa-solid fa-save"></i> Save</button>
  }
</div>
</div>
</div>

<ng-template #VerifyEmailOtp let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <h2 class="title">Email Verification</h2>
    <label class="input">
      <input class="input__field" type="email" placeholder=" " [(ngModel)]="email" />
      <span class="input__label">Email</span>
    </label>
    <label class="input">
      <button class="btn btn-dark btn-otp" (click)="sendEmailOtp()">
        Send OTP<span *ngIf="delaySendOTP > 0" class="ml-2">({{ delaySendOTP }})</span>
      </button>
      <input class="input__field" placeholder=" " type="text" name="selectedMemberPassword" pattern="\d*" maxlength="6"
        autofocus [(ngModel)]="selectedOTP" required />
      <span class="input__label" (click)="sendEmailOtp()">Enter OTP</span>
    </label>
    <p class="error-message p-0" *ngIf="invalidOtp">{{ invalidOtp }}</p>
    <button class="my-button-3" (click)="verifyEmailOtp()">Verify <i class="fa fa-thumbs-up"
        aria-hidden="true"></i></button>

    <!-- <div class="referral-link">
      <div class="form-group col-12 mt-2">
        <label>Email</label>
        <div class="d-flex">
          <input class="form-control" type="email" placeholder=" " [(ngModel)]="email" />
          <button *ngIf="!isEmailVerify" class="btn btn-secondary mb-2 mx-2" style="width: 36%" (click)="sendEmailOtp()"><i class="fa fa-envelope"></i> Send OTP</button>
        </div>
      </div>

      <section class="m-4">
        <div class="form-group">
          <input placeholder="Enter OTP" type="text" name="selectedMemberPassword" pattern="\d*" maxlength="6" autofocus class="otp-input w-100" [(ngModel)]="selectedOTP" required />
        </div>
        <p class="error-message p-0" *ngIf="invalidOtp">{{ invalidOtp }}</p>
      </section>
      <div class="mt-4">
        <div class="cart_btn">
          <button class="com_btn add-review-btn px-2" (click)="verifyEmailOtp()">Verify <i class="fa fa-thumbs-up" aria-hidden="true"></i></button>
        </div>
      </div>
    </div> -->
  </div>
</ng-template>

<ng-template #VerifyCardOtp let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <h2 class="title">Remove Card</h2>

    <br />
    <br />
    <br />
    <button class="my-button-3 right" (click)="removecardconfirm()">Remove card <i class="fa fa-thumbs-up"
        aria-hidden="true"></i></button>
  </div>
</ng-template>
<ng-template #AISettingTabModal let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <div class="card rounded-lg border-0 mb-3 p-3">
      <div class="card-body">
        <app-my-tabs [tabs]="AISettingsTab">
          <div tab0>
            <app-chatlearn></app-chatlearn>
          </div>
          <div tab1>
            <app-chatmemory></app-chatmemory>
          </div>
        </app-my-tabs>
      </div>
    </div>
  </div>
</ng-template>